<main id="main" class="main">
  <section class="section dashboard">
    <div class="row">
      <div class="col-sm-12">
        <form class="plansform">
          <div class="row mt-3">
            <div class="row">
              <div class="col-12 mb-2">
                <h6 class="admintitle" style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  ">
                  <div>
                    {{lang.Overview}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </div>
                  <button (click)="editCorporate()" on style="
                      background-color:white;
                      border: 0px;
                      color:#142a49;
                      padding: 5px;
                      border-radius: 5px;
                    ">
                    <!-- <i class="bi bi-pencil-fill" style="color: white; margin-right: 5px"></i> -->
                    {{lang.Edit}}
                  </button>
                </h6>
              </div>

              <div class="tilesContainer row">
                <!-- Parent information -->

                <div *ngIf="parentBrokerName" class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.Parent_Information}}</span>
                    </div>
                    <div class="_card_body advisor_card">
                      <div class="_card_body_image">
                        <img class="widHigSvgIcon" src="./../assets/img/booklets.png" />
                      </div>
                      <div class="_card_body_body p-2">
                        <div>
                          <!-- <span class="ftsize12">
                            <img
                              class="widHigSvgIcon"
                              src="./../assets/img/planholder.svg"
                              alt
                            />
                          </span> -->
                          <span>
                            <!-- {{ parentBrokerName }} -->
                            <div *ngIf="brokerHierarchy.length > 0">
                              <ul style="padding-left: 0px">
                                <ng-container *ngFor="
                                    let bh of brokerHierarchy;
                                    let i = index
                                  ">
                                  <li class="text-center">
                                    <div *ngIf="i != 0" class="vertical-line"></div>
                                    <span [ngStyle]="
                                        i == brokerHierarchy.length - 1
                                          ? { background: 'yellow' }
                                          : { background: 'transparent' }
                                      ">{{ bh.name }}</span>
                                  </li>
                                </ng-container>
                              </ul>
                            </div>
                          </span>
                        </div>
                      </div>
                      <!-- <div class = "_card_body_footer">
                  </div> -->
                    </div>
                  </div>
                </div>

                <!-- Advisor information -->

                <div *ngIf="brokerinfoName" class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span> {{lang.Advisor_Information}}</span>
                    </div>
                    <div class="_card_body advisor_card">
                      <div class="_card_body_image">
                        <img class="widHigSvgIcon" src="./../assets/img/Plans.png" />
                      </div>
                      <div class="_card_body_body tileMarginDown p-2">
                        <div style="
                            float: right;
                            text-align: right;
                            display: flex;
                            margin-top: 0px;
                            margin-bottom: 10px;
                          " class="ftsize16">
                          &nbsp;&nbsp;
                          <i class="bi bi-pencil-square" data-bs-toggle="modal" data-bs-target="#advisorModal"
                            (click)="editAdvisor()" style="color: #1429a9; cursor: pointer" title="Edit"></i>
                        </div>

                        <div class="flex-styles">
                          <div style="width: 10%" title="Broker Name">
                            <img class="widHigSvgIcon" src="./../assets/img/planholder.svg" alt />
                          </div>
                          <div>
                            {{ brokerinfoName }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div style="width: 10%" type="Broker Type">
                            <img class="widHigSvgIcon" src="./../assets/img/RoleImage.png" alt />
                          </div>
                          <div style="text-transform: capitalize">
                            {{ transformText(brokerinfobrokerType) }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div style="width: 10%" title="Primary Email">
                            <img class="widHigSvgIcon" src="./../assets/img/email.svg" alt />
                          </div>
                          <div title="{{ brokerDetails?.primaryEmail }}">
                            {{
                            brokerDetails?.primaryEmail?.length > 34
                            ? brokerDetails?.primaryEmail?.slice(0, 24) +
                            "..."
                            : brokerDetails?.primaryEmail
                            }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div style="width: 10%" title="Primary Phone">
                            <img class="widHigSvgIcon" src="./../assets/img/tel.svg" alt />
                          </div>
                          <div>
                            {{
                            brokerDetails?.primaryPhone &&
                            brokerDetails?.primaryPhone.split(")")[0] +
                            ") " +
                            brokerDetails?.primaryPhone.split(")")[1]
                            }}
                          </div>
                        </div>
                        <div class="flex-styles mt-2" *ngIf="brokerinfobrokerType === 'BROKERAGE'">
  <div style="width: 10%" title="Business Number">
    <!-- <img class="widHigSvgIcon" src="./../assets/img/mobile.svg" alt /> -->
      <i class="fa fa-id-card-o fa-2x widHigSvgIcon" aria-hidden="true" title="Business Number"></i>

  </div>
  <div style="margin-left: 7px">
    {{ businessNumber }}
  </div>
</div>


                        <div class="flex-styles mt-2">
                          <div style="width: 10%" title="Address">
                            <img class="widHigSvgIcon" src="./../assets/img/location.svg" alt />
                          </div>
                          <div style="margin-left: 7px">
                            {{ brokerDetails?.line1 }}
                            {{
                            brokerDetails?.line2 &&
                            ", " + brokerDetails?.line2
                            }}
                            {{ brokerDetails?.city }},
                            {{ brokerDetails?.state }},
                            {{ brokerDetails?.postalCode }},
                            {{ brokerDetails?.country }}
                          </div>
                        </div>
                      </div>
                      <!-- <div class = "_card_body_footer">
                    </div> -->
                    </div>
                  </div>
                </div>

                <!-- {{lang.Group_Contacts}} single -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="groupContacts?.length == 1">
                  <div>
                    <div class="_card p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Group_Contacts}}
                        <button data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="clearAdminForm()"
                          class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button>
                      </div>
                      <div class="_card_body" *ngFor="let admin of groupContacts; let i = index">
                        <div class="_card_body_image p-0 pb-0">
                          <img id="image" src="/assets/img/Group_contacts.png"
                            style="width: 100%; height: 100%; object-fit: cover" />
                        </div>
                        <div class="_card_body_body py-2 px-1 tileMarginDown groupContactsBgClr">
                          <div style="
                              float: right;
                              text-align: right;
                              display: flex;
                              margin-top: 0px;
                              margin-bottom: 10px;
                            " class="ftsize16">
                            &nbsp;&nbsp;
                            <i class="bi bi-pencil-square" data-bs-toggle="modal" data-bs-target="#basicModaledit"
                              (click)="editadmin(admin, i)" style="color: #1429a9; cursor: pointer" title="Edit"></i>
                            &nbsp;&nbsp;
                            <i class="bi bi-trash-fill redClr" *ngIf="groupContacts.length>1" (click)="deleteadmin(admin, i)"
                              style="color: red; cursor: pointer" title="Delete"></i>
                          </div>
                          <div class="flex-styles">
                            <div style="width: 10%" title="Name">
                              <img class="widHigSvgIcon" src="./../assets/img/planholder.svg" alt />
                            </div>
                            <div style="margin-top: 2px">
                              {{ admin.firstName }}
                              {{ admin.lastName }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div style="width: 10%" title="Phone">
                              <img class="widHigSvgIcon" src="./../assets/img/mobile.svg" alt />
                            </div>
                            <div>
                              {{
                              admin?.phoneNum &&
                              admin?.phoneNum.split(")")[0] +
                              ") " +
                              admin?.phoneNum.split(")")[1]
                              }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div style="width: 10%" title="Email">
                              <img class="widHigSvgIcon" src="./../assets/img/email.svg" alt />
                            </div>
                            <div>
                              {{
                              admin.email?.length > 34
                              ? admin.email?.slice(0, 24) + "..."
                              : admin.email
                              }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div style="width: 10%" title="Role">
                              <img class="widHigSvgIcon" src="./../assets/img/RoleImage.png" alt />
                            </div>
                            <div style="margin-top: 2px">
                              <div *ngIf="admin.role == 'ADVISOR_ADMINISTRATOR'">
                                {{lang.Administrator}}
                              </div>
                              <div *ngIf="admin.role == 'ADVISOR_EXECUTIVE'">
                                {{lang.Executive}}
                              </div>
                              <div *ngIf="admin.role == 'ADVISOR_CONTACT'">
                                {{lang.Support}}
                              </div>
                              <div *ngIf="admin.role == 'CORPORATE_ADMIN'">
                                {{lang.System_Administrator}}
                              </div>
                              <div *ngIf="admin.role == 'ADVISOR_OTHERS'">
                                {{ admin.roleName }}
                              </div>
                              <div *ngIf="
                                  admin.role !== 'ADVISOR_ADMINISTRATOR' &&
                                  admin.role !== 'ADVISOR_EXECUTIVE' &&
                                  admin.role !== 'ADVISOR_CONTACT' &&
                                  admin.role !== 'ADVISOR_OTHERS'
                                ">
                                {{ admin.role }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- {{lang.Group_Contacts}} -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                    groupContacts?.length > 1 || groupContacts?.length === 0
                  ">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Group_Contacts}}
                        <button data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="clearAdminForm()"
                          class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button>
                      </div>
                      <div class="mt-2">
                        <div *ngIf="groupContacts.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper tranding-slider swiper-container">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let admin of groupContacts;
                                    let i = index
                                  ">
                                  <div class="card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/Group_contacts.png" style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                        " />
                                    </div>
                                    <div class="card-body py-2 px-1 groupContactsBgClr tileheight">
                                      <div class="ms-2">
                                        <div style="
                                            float: right;
                                            text-align: right;
                                            display: flex;
                                            margin-top: 0px;
                                          " class="ftsize16">
                                          &nbsp;&nbsp;
                                          <i class="bi bi-pencil-square" data-bs-toggle="modal"
                                            data-bs-target="#basicModaledit" (click)="editadmin(admin, i)" style="
                                              color: #1429a9;
                                              cursor: pointer;
                                            " title="Edit"></i>
                                          &nbsp;&nbsp;
                                          <i class="bi bi-trash-fill redClr" (click)="deleteadmin(admin, i)"
                                            style="color: red; cursor: pointer" title="Delete"></i>
                                        </div>

                                        <div class="flex-styles">
                                          <div style="width: 10%" title="Name">
                                            <img class="widHigSvgIcon" src="./../assets/img/planholder.svg" alt />
                                          </div>
                                          <div style="margin-top: 2px">
                                            {{ admin.firstName }}
                                            {{ admin.lastName }}
                                          </div>
                                        </div>

                                        <div class="flex-styles mt-2">
                                          <div style="width: 10%" title="Phone">
                                            <img class="widHigSvgIcon" src="./../assets/img/mobile.svg" alt />
                                          </div>
                                          <div>
                                            {{
                                            admin?.phoneNum &&
                                            admin?.phoneNum.split(")")[0] +
                                            ") " +
                                            admin?.phoneNum.split(")")[1]
                                            }}
                                          </div>
                                        </div>

                                        <div class="flex-styles mt-2">
                                          <div style="width: 10%" title="Email">
                                            <img class="widHigSvgIcon" src="./../assets/img/email.svg" alt />
                                          </div>
                                          <div>
                                            {{
                                            admin.email?.length > 34
                                            ? admin.email?.slice(0, 24) +
                                            "..."
                                            : admin.email
                                            }}
                                          </div>
                                        </div>

                                        <div class="flex-styles mt-2">
                                          <div style="width: 10%" title="Role">
                                            <img class="widHigSvgIcon" src="./../assets/img/RoleImage.png" alt />
                                          </div>
                                          <div style="margin-top: 2px">
                                            <div *ngIf="
                                                admin.role ==
                                                'ADVISOR_ADMINISTRATOR'
                                              ">
                                              {{lang.Administrator}}
                                            </div>
                                            <div *ngIf="
                                                admin.role ==
                                                'ADVISOR_EXECUTIVE'
                                              ">
                                              {{lang.Executive}}
                                            </div>
                                            <div *ngIf="
                                                admin.role == 'ADVISOR_CONTACT'
                                              ">
                                              {{lang.Support}}
                                            </div>
                                            <div *ngIf="
                                                admin.role == 'CORPORATE_ADMIN'
                                              ">
                                              {{lang.System_Administrator}}
                                            </div>
                                            <div *ngIf="
                                                admin.role == 'ADVISOR_OTHERS'
                                              ">
                                              {{ admin.roleName }}
                                            </div>
                                            <div *ngIf="
                                                admin.role !==
                                                  'ADVISOR_ADMINISTRATOR' &&
                                                admin.role !==
                                                  'ADVISOR_EXECUTIVE' &&
                                                admin.role !==
                                                  'ADVISOR_CONTACT' &&
                                                admin.role !== 'ADVISOR_OTHERS'
                                              ">
                                              {{ admin.role }}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="groupContacts.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--  single -->
                <!-- <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2"
                  *ngIf="brokerLicensedStatesAndProvinces?.length == 1">
                  <div>
                    <div class="_card p-0">
                      <div class="_card_title ftsize12">
                        {{lang.License_Information}}

                        <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+Add</strong>
                        </button>
                      </div>
                      <div class="_card_body enroll_card" *ngIf="brokerLicensedStatesAndProvinces?.length == 1">
                        <div class="_card_body_image p-0">
                          <img id="image" src="/assets/img/invoices.png"
                            style="width: 100%; height: 100%; object-fit: cover" />
                        </div>
                        <div class="py-2 px-1 _card_body_body tileMarginDown" *ngFor="
                            let license of brokerLicensedStatesAndProvinces;
                            let i = index
                          ">
                          <div style="
                              float: right;
                              text-align: right;
                              display: flex;
                              margin-top: 0px;
                              margin-bottom: 10px;
                            " class="ftsize16">
                            &nbsp;&nbsp;
                            <i class="bi bi-pencil-square" data-bs-toggle="modal" data-bs-target="#licenseedit" (click)="
                                editadvisorlicenseDetails($event, i, license)
                              " style="color: #1429a9; cursor: pointer" title="Edit"></i>
                            &nbsp;&nbsp;
                            <i class="bi bi-trash-fill redClr" (click)="deletelicense(license, i)"
                              style="color: red; cursor: pointer" title="Delete"></i>
                          </div>
                          <div class="flex-styles">
                            <div class="licenseWidth">License #</div>
                            <div>
                              {{ license.licenseNumber }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="licenseWidth">Coverage</div>
                            <div style="text-transform: capitalize" [class.coverage-text]="
                                license.licenseCoverage.length > 10
                              ">
                              {{ replaceUnderScores(license.licenseCoverage) }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="licenseWidth">Province</div>
                            <div>
                              {{ license.stateFullDetails["shortName"] }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="licenseWidth">Expiry Date</div>
                            <div>
                              {{ license.expiryDate }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="licenseWidth">Reminder Days</div>
                            <div>
                              {{ license.reminderEmail }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <!--  single broker license -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="brokerLicensesGrouped?.length == 1">
                  <div>
                    <div class="_card p-0">
                      <div class="_card_title ftsize12">
                        {{lang.License_Information}}

                        <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button>
                      </div>
                      <div class="_card_body enroll_card license_card" *ngIf="brokerLicensesGrouped?.length == 1">
                        <div class="_card_body_image p-0">
                          <img id="image" src="/assets/img/invoices.png"
                            style="width: 100%; height: 100%; object-fit: cover" />
                        </div>
                        <div class="py-2 px-2 _card_body_body tileMarginDown" *ngFor="
                            let license of brokerLicensesGrouped;
                            let i = index
                          ">
                          <!-- <div
                            style="
                              float: right;
                              text-align: right;
                              display: flex;
                              margin-top: 0px;
                              margin-bottom: 10px;
                            "
                            class="ftsize16"
                          >
                            &nbsp;&nbsp;
                            <i
                              class="bi bi-pencil-square"
                              data-bs-toggle="modal"
                              data-bs-target="#licenseedit"
                              (click)="
                                editadvisorlicenseDetails($event, i, license)
                              "
                              style="color: #1429a9; cursor: pointer"
                              title="Edit"
                            ></i>
                            &nbsp;&nbsp;
                            <i
                              class="bi bi-trash-fill redClr"
                              (click)="deletelicense(license, i)"
                              style="color: red; cursor: pointer"
                              title="Delete"
                            ></i>
                          </div> -->
                          <!-- <div class="flex-styles">
                            <div class="licenseWidth">License #</div>
                            <div>
                              {{ license.licenseNumber }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="licenseWidth">Coverage</div>
                            <div style="text-transform: capitalize" [class.coverage-text]="
                                license.licenseCoverage.length > 10
                              ">
                              {{ replaceUnderScores(license.licenseCoverage) }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="licenseWidth">Province</div>
                            <div>
                              {{ license.stateFullDetails["shortName"] }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="licenseWidth">Expiry Date</div>
                            <div>
                              {{ license.expiryDate }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="licenseWidth">Reminder Days</div>
                            <div>
                              {{ license.reminderEmail }}
                            </div>
                          </div> -->
                          <div class="mt-2">
                            <div style="font-size: 17px; text-align: center">
                              {{ license.licenses[0]?.stateFullDetails?.name }}
                            </div>
                          </div>
                          <div class="license-table">
                            <table class="table border-0 bg-transparent">
                              <thead>
                                <th>{{lang.License}}#</th>
                                <th>{{lang.Coverage}}</th>
                                <th>{{lang.Expiry_Date}}</th>
                                <th class="d-flex flex-column">
                                  <!-- <span>Remind</span><span>(in days)</span> -->
                                  {{lang.Reminder_Days}}
                                </th>
                                <th>{{lang.Actions}}</th>
                              </thead>
                              <tbody>
                                <tr *ngFor="
                                    let li of license.licenses;
                                    let index = index
                                  ">
                                  <td class="text-nowrap
                                  ">
                                    {{
                                    li.licenseNumber.length > 10
                                    ? li.licenseNumber.slice(0, 10) + "..."
                                    : li.licenseNumber
                                    }}
                                  </td>
                                  <td class="text-nowrap text-capitalize" data-bs-toggle="tooltip"
                                    data-bs-placement="top" title="{{
                                      customizeCoverage(li.licenseCoverage)
                                    }}">
                                    {{
                                    customizeCoverage(li.licenseCoverage)
                                    .length > 13
                                    ? customizeCoverage(
                                    li.licenseCoverage
                                    ).slice(0, 13) + "..."
                                    : customizeCoverage(li.licenseCoverage)
                                    }}
                                  </td>
                                  <td class="text-nowrap">
                                    {{ convertDate(li.expiryDate) }}
                                  </td>
                                  <td class="text-center">
                                    {{ li.reminderEmail }}
                                  </td>
                                  <td>
                                    <i class="bi bi-pencil-square" data-bs-toggle="modal" data-bs-target="#licenseedit"
                                      (click)="
                                        editadvisorlicenseDetails(
                                          $event,
                                          index,
                                          li
                                        )
                                      " style="color: #1429a9; cursor: pointer" title="Edit"></i>
                                    &nbsp;&nbsp;
                                    <i class="bi bi-trash-fill redClr" (click)="deletelicense(li, index)"
                                      style="color: red; cursor: pointer" title="Delete"></i>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- {{lang.License_Information}} -->
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                    brokerLicensesGrouped?.length > 1 ||
                    brokerLicensesGrouped?.length === 0
                  ">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        {{lang.License_Information}}
                        <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button>
                      </div>
                      <div class="mt-2">
                        <div *ngIf="brokerLicensesGrouped?.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let license of brokerLicensesGrouped;
                                    let i = index
                                  ">
                                  <div class="card _activecard enroll_card p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/invoices.png" style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                        " />
                                    </div>
                                    <div style="padding-left: 10px" class="card-body tileMarginDown py-2 tileheight">
                                      <!-- <div
                                        style="
                                          float: right;
                                          text-align: right;
                                          display: flex;
                                          margin-top: 0px;
                                          margin-bottom: 10px;
                                        "
                                        class="ftsize16"
                                      >
                                        &nbsp;&nbsp;
                                        <i
                                          class="bi bi-pencil-square"
                                          data-bs-toggle="modal"
                                          data-bs-target="#licenseedit"
                                          (click)="
                                            editadvisorlicenseDetails(
                                              $event,
                                              i,
                                              license
                                            )
                                          "
                                          style="
                                            color: #1429a9;
                                            cursor: pointer;
                                          "
                                          title="Edit"
                                        ></i>
                                        &nbsp;&nbsp;
                                        <i
                                          class="bi bi-trash-fill redClr"
                                          (click)="deletelicense(license, i)"
                                          style="color: red; cursor: pointer"
                                          title="Delete"
                                        ></i>
                                      </div> -->

                                      <!-- <div class="flex-styles">
                                        <div class="licenseWidth">
                                          License #
                                        </div>
                                        <div>
                                          {{ license.licenseNumber }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="licenseWidth">Coverage</div>
                                        <div
                                          [class.coverage-text]="
                                            license.licenseCoverage.length > 10
                                          "
                                        >
                                          {{
                                            replaceUnderScores(
                                              license.licenseCoverage
                                            )
                                          }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="licenseWidth">Province</div>
                                        <div>
                                          {{
                                            license.stateFullDetails[
                                              "shortName"
                                            ]
                                          }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="licenseWidth">
                                          Expiry Date
                                        </div>
                                        <div>
                                          {{ license.expiryDate }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="licenseWidth">
                                          Reminder Days
                                        </div>
                                        <div>
                                          {{ license.reminderEmail }}
                                        </div>
                                      </div> -->
                                      <div>
                                        <div style="
                                            font-size: 17px;
                                            text-align: center;
                                          ">
                                          {{
                                          license.licenses[0].stateFullDetails
                                          .name
                                          }}
                                        </div>
                                      </div>
                                      <div class="license-table mt-1">
                                        <table class="table border-0 bg-transparent">
                                          <thead>
                                            <th>{{lang.License}}#</th>
                                            <th>{{lang.Coverage}}</th>
                                            <th>{{lang.Expiry_Date}}</th>
                                            <th class="d-flex flex-column">
                                              <!-- <span>Remind</span><span>(in days)</span> -->
                                              {{lang.Reminder_Days}}
                                            </th>
                                            <th>{{lang.Actions}}</th>
                                          </thead>
                                          <tbody>
                                            <tr *ngFor="
                                                let li of license.licenses;
                                                let index = i
                                              ">
                                              <td data-bs-toggle="tooltip" data-bs-placement="top" title="{{
                                                  customizeCoverage(
                                                    li.licenseNumber
                                                  )
                                                }}">
                                                {{
                                                li.licenseNumber.length > 10
                                                ? li.licenseNumber.slice(
                                                0,
                                                10
                                                ) + "..."
                                                : li.licenseNumber
                                                }}
                                              </td>
                                              <td class="text-nowrap text-capitalize" data-bs-toggle="tooltip"
                                                data-bs-placement="top" title="{{
                                                  customizeCoverage(
                                                    li.licenseCoverage
                                                  )
                                                }}">
                                                {{
                                                customizeCoverage(
                                                li.licenseCoverage
                                                ).length > 12
                                                ? customizeCoverage(
                                                li.licenseCoverage
                                                ).slice(0, 12) + "..."
                                                : customizeCoverage(
                                                li.licenseCoverage
                                                )
                                                }}
                                              </td>
                                              <td class="text-nowrap">
                                                {{ convertDate(li.expiryDate) }}
                                              </td>
                                              <td class="text-center">
                                                {{ li.reminderEmail }}
                                              </td>
                                              <td>
                                                <i class="bi bi-pencil-square" data-bs-toggle="modal"
                                                  data-bs-target="#licenseedit" (click)="
                                                    editadvisorlicenseDetails(
                                                      $event,
                                                      index,
                                                      li
                                                    )
                                                  " style="
                                                    color: #1429a9;
                                                    cursor: pointer;
                                                  " title="Edit"></i>
                                                &nbsp;&nbsp;
                                                <i class="bi bi-trash-fill redClr" (click)="
                                                    deletelicense(li, index)
                                                  " style="
                                                    color: red;
                                                    cursor: pointer;
                                                  " title="Delete"></i>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="brokerLicensedStatesAndProvinces.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Multiple {{lang.License_Information}} -->
                <!-- <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                brokerLicensesGrouped?.length > 1 ||
                brokerLicensesGrouped?.length === 0
              ">
              <div>
                <div class="_card paymentCard2 p-0">
                  <div class="_card_title ftsize12">
                    {{lang.License_Information}}
                    <button data-bs-toggle="modal" data-bs-target="#addLicenseModal" class="addgroupadmininfoemp">
                      <strong>+Add</strong>
                    </button>
                  </div>
                  <div class="mt-2">
                    <div *ngIf="brokerLicensesGrouped?.length > 1">
                      <section id="tranding" class="tranding-style">
                        <div class="swiper-container tranding-slider">
                          <div class="swiper-wrapper">
                            <div class="swiper-slide tranding-slide" *ngFor="
                                let license of brokerLicensesGrouped;
                                let i = index
                              ">
                              <div class="card _activecard enroll_card p-0 pb-0">
                                <div class="card-header p-0" style="height: 28%">
                                  <img id="image" src="/assets/img/invoices.png" style="
                                      width: 100%;
                                      height: 100%;
                                      object-fit: cover;
                                    " />
                                </div>
                                <div style="padding-left: 10px" class="card-body tileMarginDown py-2 tileheight">
                                  <div style="
                                      float: right;
                                      text-align: right;
                                      display: flex;
                                      margin-top: 0px;
                                      margin-bottom: 10px;
                                    " class="ftsize16">
                                    &nbsp;&nbsp;
                                    <i class="bi bi-pencil-square" data-bs-toggle="modal"
                                      data-bs-target="#licenseedit" (click)="
                                        editadvisorlicenseDetails(
                                          $event,
                                          i,
                                          license
                                        )
                                      " style="
                                        color: #1429a9;
                                        cursor: pointer;
                                      " title="Edit"></i>
                                    &nbsp;&nbsp;
                                    <i class="bi bi-trash-fill redClr" (click)="deletelicense(license, i)"
                                      style="color: red; cursor: pointer" title="Delete"></i>
                                  </div>

                                  <div class="flex-styles">
                                    <div class="licenseWidth">
                                      License #
                                    </div>
                                    <div>
                                      {{ license.licenseNumber }}
                                    </div>
                                  </div>

                                  <div class="flex-styles mt-2">
                                    <div class="licenseWidth">Coverage</div>
                                    <div [class.coverage-text]="
                                        license.licenseCoverage.length > 10
                                      ">
                                      {{
                                      replaceUnderScores(
                                      license.licenseCoverage
                                      )
                                      }}
                                    </div>
                                  </div>

                                  <div class="flex-styles mt-2">
                                    <div class="licenseWidth">Province</div>
                                    <div>
                                      {{
                                      license.stateFullDetails[
                                      "shortName"
                                      ]
                                      }}
                                    </div>
                                  </div>

                                  <div class="flex-styles mt-2">
                                    <div class="licenseWidth">
                                      Expiry Date
                                    </div>
                                    <div>
                                      {{ license.expiryDate }}
                                    </div>
                                  </div>

                                  <div class="flex-styles mt-2">
                                    <div class="licenseWidth">
                                      Reminder Days
                                    </div>
                                    <div>
                                      {{ license.reminderEmail }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="controlCard1">
                            <div class="tranding-slider-control">
                              <div class="swiper-button-prev2 ftsize20">
                                <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                              </div>

                              <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                              <div class="swiper-button-next2 ftsize20">
                                <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div class="text-center" *ngIf="brokerLicensedStatesAndProvinces.length == 0">
                      {{lang.No_Data_Available}}
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
                <!-- Sales Tracking Code -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                    salesTrackingCodeShares?.length > 1 ||
                    salesTrackingCodeShares?.length === 0
                  ">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Sales_Tracking_Code}}
                      </div>
                      <div class="mt-2">
                        <div *ngIf="salesTrackingCodeShares?.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let sales of salesTrackingCodeShares;
                                    let i = index
                                  ">
                                  <div class="card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/Proposal_Progress.png" style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                        " />
                                    </div>
                                    <div class="card-body py-2 px-2 plans_card tileheight">
                                      <div style="
                                          float: right;
                                          text-align: right;
                                          display: flex;
                                          margin-top: 0px;
                                          margin-bottom: 10px;
                                        " class="ftsize16">
                                        &nbsp;&nbsp;
                                        <!-- <i class="bi bi-pencil-square" data-bs-toggle="modal"
                                          data-bs-target="#salesTrackingEdit" (click)="
                                            editSaleslTrackingCode(
                                              $event,
                                              i,
                                              sales
                                            )
                                          " style="
                                            color: #1429a9;
                                            cursor: pointer;
                                          " title="Edit"></i> -->
                                        &nbsp;&nbsp;
                                      </div>

                                      <!-- <div class="flex-styles">
                                        <div class="salesWidth">Code</div>
                                        <div>
                                          {{ sales.salesTrackingCode.code }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="salesWidthSingle">
                                          {{lang.Coverages}}
                                        </div>
                                        <div
                                          style="
                                            display: flex;
                                            flex-direction: column;
                                          "
                                        >
                                          <div
                                            *ngFor="
                                              let name of getBrokerNames(sales);
                                              let i = index
                                            "
                                            style="
                                              width: 100%;
                                              display: flex;
                                              gap: 10px;
                                              justify-content: space-between;
                                            "
                                          >
                                            <div
                                              style="
                                                flex: 0.8;
                                                white-space: nowrap;
                                              "
                                            >
                                              {{ name }}
                                            </div>
                                            <div style="flex: 0.2">
                                              ({{
                                                getBrokerPercentages(sales)[i]
                                              }}%)<br />
                                            </div>
                                          </div>
                                        </div>
                                      </div> -->
                                      <table class="table border-0 bg-transparent">
                                        <tbody class="d-inline">
                                          <tr>
                                            <td>{{lang.Code}}</td>
                                            <td>
                                              {{ sales.salesTrackingCode.code }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>{{lang.Coverages}}</td>
                                            <td class="text-wrap">
                                              <table class="table border-0 bg-transparent">
                                                <tbody>
                                                  <tr *ngFor="
                                                      let name of getBrokerNames(
                                                        sales
                                                      );
                                                      let i = index
                                                    ">
                                                    <td>{{ name }}</td>
                                                    <td>
                                                      ({{
                                                      getBrokerPercentages(
                                                      sales
                                                      )[i]
                                                      }}%)
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="salesTrackingCodeShares?.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Sales Tracking Code Single -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="salesTrackingCodeShares?.length == 1">
                  <div>
                    <div class="_card p-0">
                      <div class="_card_title ftsize12">
                        {{lang.Sales_Tracking_Code}}
                      </div>
                      <div class="_card_body plans_card">
                        <div class="_card_body_image p-0">
                          <img id="image" src="/assets/img/Proposal_Progress.png"
                            style="width: 100%; height: 100%; object-fit: cover" />
                        </div>
                        <div class="py-2 px-1 _card_body_body tileMarginDown" *ngFor="
                            let sales of salesTrackingCodeShares;
                            let i = index
                          ">
                          <div style="
                              float: right;
                              text-align: right;
                              display: flex;
                              margin-top: 0px;
                              margin-bottom: 10px;
                            " class="ftsize16">
                            &nbsp;&nbsp;
                            <!-- <i class="bi bi-pencil-square" data-bs-toggle="modal" data-bs-target="#salesTrackingEdit"
                              (click)="editSaleslTrackingCode($event, i, sales)" style="color: #1429a9; cursor: pointer"
                              title="Edit"></i> -->
                          </div>

                          <div class="flex-styles">
                            <div class="salesWidthSingle">Code</div>
                            <div style="
                            width: 100%;
                            display: flex;
                            gap: 10px;
                            justify-content: space-between;flex: 0.8; white-space: nowrap
                          ">
                              {{ sales.salesTrackingCode.code }}
                            </div>
                          </div>

                          <div class="flex-styles mt-2">
                            <div class="salesWidthSingle">{{lang.Coverages}}</div>
                            <div style="display: flex; flex-direction: column">
                              <div *ngFor="
                                  let name of getBrokerNames(sales);
                                  let i = index
                                " style="
                                  width: 100%;
                                  display: flex;
                                  gap: 10px;
                                  justify-content: space-between;
                                ">
                                <div style="flex: 0.8; white-space: nowrap">
                                  {{ name }}
                                </div>
                                <div style="flex: 0.2">
                                  ({{ getBrokerPercentages(sales)[i] }}%)<br />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- {{lang.E_O_Information}} -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                    brokerEOinformation?.length > 1 ||
                    brokerEOinformation?.length === 0
                  ">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        {{lang.E_O_Information}}<button *ngIf="brokerEOinformation?.length == 0" data-bs-toggle="modal"
                          data-bs-target="#addEoInfo" class="addgroupadmininfoemp">
                          <strong>+{{lang.Add}}</strong>
                        </button>
                      </div>
                      <div class="mt-2">
                        <div *ngIf="brokerEOinformation?.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let broker of brokerEOinformation;
                                    let i = index
                                  ">
                                  <div class="card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/enrollment_summary.png" style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                        " />
                                    </div>
                                    <div class="card-body py-2 px-2 payment_card tileheight">
                                      <div style="
                                          float: right;
                                          text-align: right;
                                          display: flex;
                                          margin-top: 0px;
                                          margin-bottom: 10px;
                                        " class="ftsize16">
                                        &nbsp;&nbsp;
                                        <!-- <i

                                class="bi bi-pencil-square"
                                data-bs-toggle="modal"
                                data-bs-target="#basicModaleditEO"
                                (click)="editadvisorEODetails($event, i, broker)"
                                style="color: #1429a9; cursor: pointer"
                                title="Edit"
                                ></i> -->
                                        &nbsp;&nbsp;
                                        <i class="bi bi-trash-fill redClr" (click)="deleteEO(broker, i)"
                                          style="color: red; cursor: pointer" title="Delete"></i>
                                      </div>

                                      <div class="flex-styles">
                                        <div class="licenseWidth">
                                          {{lang.Insurer_Name}}
                                        </div>
                                        <div>
                                          {{ broker.insurerName }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="licenseWidth">
                                          {{lang.Certificate}} #
                                        </div>
                                        <div>
                                          {{ broker.certificateNumber }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="licenseWidth">{{lang.Policy}} #</div>
                                        <div>
                                          {{ broker.policyNumbe }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="licenseWidth">
                                          {{lang.Expiry_Date}}
                                        </div>
                                        <div>
                                          {{ broker.expiryDate }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="brokerEOinformation?.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- {{lang.E_O_Information}} Single -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="brokerEOinformation?.length == 1">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <span>{{lang.E_O_Information}}</span>
                    </div>
                    <div class="_card_body payment_card advisor_card">
                      <div class="_card_body_image">
                        <img class="widHigSvgIcon" src="./../assets/img/enrollment_summary.png" />
                      </div>
                      <div class="_card_body_body p-2" *ngFor="
                          let broker of brokerEOinformation;
                          let i = index
                        ">
                        <div style="
                            float: right;
                            text-align: right;
                            display: flex;
                            margin-top: 0px;
                            margin-bottom: 10px;
                          " class="ftsize16">
                          &nbsp;&nbsp;
                          <i

                                class="bi bi-pencil-square"
                                data-bs-toggle="modal"
                                data-bs-target="#basicModaleditEO"
                                (click)="editadvisorEODetails($event, i, broker)"
                                style="color: #1429a9; cursor: pointer"
                                title="Edit"
                                ></i>
                          &nbsp;&nbsp;
                          <i class="bi bi-trash-fill redClr" (click)="deleteEO(broker, i)"
                            style="color: red; cursor: pointer" title="Delete"></i>
                        </div>

                        <div class="flex-styles">
                          <div class="eoWidth">{{lang.Insurer_Name}}</div>
                          <div>
                            {{ broker.insurerName }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div class="eoWidth">{{lang.Certificate}} #</div>
                          <div>
                            {{ broker.certificateNumber }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div class="eoWidth">{{lang.Policy}} #</div>
                          <div>
                            {{ broker.policyNumber }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div class="eoWidth">{{lang.Expiry_Date}}</div>
                          <div>
                            {{ broker.expiryDate }}
                          </div>
                        </div>
                      </div>
                      <!-- <div class = "_card_body_footer">
                </div> -->
                    </div>
                  </div>
                </div>

                <!-- Signup Form Information -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="brokerFormData?.length == 1">
                  <div class="_card">
                    <div class="_card_title ftsize12">
                      <!-- <span>{{lang.Signup_Form_Information}}</span> -->
                      <span>Enrollment Form Information</span>
                      <button data-bs-toggle="modal" class="addgroupadmininfoemp"
                        (click)="addextraform()">
                        <strong>+Add</strong>
                      </button>
                    </div>
                    <div class="_card_body invoice_card">
                      <div class="_card_body_image">
                        <img class="widHigSvgIcon" src="./../assets/img/invoices.png" />
                      </div>
                      <div class="_card_body_body tileMarginDown p-2"
                        *ngFor="let broker of brokerFormData; let i = index">
                        <div style="
                            float: right;
                            text-align: right;
                            display: flex;
                            margin-top: 0px;
                            margin-bottom: 10px;
                          " class="ftsize16">
                          &nbsp;&nbsp;
                          <i class="bi bi-pencil-square" data-bs-toggle="modal" 
                            (click)="editadvisorformDetails($event, i, broker)" style="color: #1429a9; cursor: pointer"
                            title="Edit"></i>
                          &nbsp;&nbsp;
                          <i class="bi bi-trash-fill redClr" (click)="deleteForm(broker, i)"
                            style="color: red; cursor: pointer" title="Delete"></i>
                        </div>
                        <div class="mt-2">
                          <div>
                            <img style="
                              height: auto;
                              max-height: 75px;
                              width: auto;
                              max-width: 100%;
                              " [src]="broker.logo" />
                          </div>
                        </div>
                        <div class="flex-styles mt-2">
  <div class="signupWidth">Link Status</div>
  <div [ngClass]="{'text-success': broker.published, 'text-danger': !broker.published}">
    {{ broker.published ? 'Active' : 'Inactive' }}
  </div>
</div>

                        <div class="flex-styles">
                          <div class="signupWidth">{{lang.Type}}</div>
                          <div style="text-transform: capitalize">
                            {{ transformText(broker.formType) }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div class="signupWidth">{{lang.Title}}</div>
                          <div>
                            {{ broker.name }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div class="signupWidth">{{lang.Description}}</div>
                          <div>
                            {{ broker.description }}
                          </div>
                        </div>

                        <div class="flex-styles mt-2">
                          <div class="signupWidth">{{lang.Link}}</div>
                          <div>
                            <a href="{{ broker.link }}" target="_blank">
                              <!-- {{lang.Signup_Link}} -->
                              Enrollment Link
                            </a>
                            <span>
                              <button id="copyButton1" style="border: none"
                                class="spanCopy1 btnSizes mt-1 ms-1 mb-2 ftsize12 cursor-pointer"
                                (click)="copyToClipboard1(broker.link)" title="Copy">
                                <a href style="
                                    pointer-events: none;
                                    font-family: sans-serif;
                                    text-decoration: none !important;
                                  ">
                                  <img src="../../assets/img/copy.svg" class="widHigSvgIcon" /></a>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- <div class = "_card_body_footer">
                    </div> -->
                    </div>
                  </div>
                </div>

                <!-- Signup Form Information -->

                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" *ngIf="
                    brokerFormData?.length > 1 || brokerFormData?.length === 0
                  ">
                  <div>
                    <div class="_card paymentCard2 p-0">
                      <div class="_card_title ftsize12">
                        <!-- {{lang.Signup_Form_Information}} -->
                        Enrollment Form Information
                        <button data-bs-toggle="modal" class="addgroupadmininfoemp"
                          (click)="addextraform()">
                          <strong>+{{lang.Add}}</strong>
                        </button>
                      </div>
                      <div class="mt-2">
                        <div *ngIf="brokerFormData?.length > 1">
                          <section id="tranding" class="tranding-style">
                            <div class="swiper-container tranding-slider">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide tranding-slide" *ngFor="
                                    let broker of brokerFormData;
                                    let i = index
                                  ">
                                  <div class="card invoice_card _activecard p-0 pb-0">
                                    <div class="card-header p-0" style="height: 28%">
                                      <img id="image" src="/assets/img/invoices.png" style="
                                          width: 100%;
                                          height: 100%;
                                          object-fit: cover;
                                        " />
                                    </div>
                                    <div class="card-body tileMarginDown py-2 px-2 tileheight">
                                      <div style="
                                          float: right;
                                          text-align: right;
                                          display: flex;
                                          margin-top: 0px;
                                          margin-bottom: 10px;
                                        " class="ftsize16">
                                        &nbsp;&nbsp;
                                        <i class="bi bi-pencil-square" data-bs-toggle="modal"
                                           (click)="
                                            editadvisorformDetails(
                                              $event,
                                              i,
                                              broker
                                            )
                                          " style="
                                            color: #1429a9;
                                            cursor: pointer;
                                          " title="Edit"></i>
                                        &nbsp;&nbsp;
                                        <i class="bi bi-trash-fill redClr" (click)="deleteForm(broker, i)"
                                          style="color: red; cursor: pointer" title="Delete"></i>
                                      </div>

                                      <div class="mt-2">
                                        <div>
                                          <img style="
                                              height: auto;
                                              max-height: 75px;
                                              width: auto;
                                              max-width: 100%;
                                            " [src]="broker.logo" />
                                        </div>
                                      </div>
                                      <div class="flex-styles">
                                        <div class="signupWidth">{{lang.Type}}</div>
                                        <div style="text-transform: capitalize">
                                          {{ transformText(broker.formType) }}
                                        </div>
                                      </div>
                                      

                                      <div class="flex-styles mt-2">
                                        <div class="signupWidth">{{lang.Title}}</div>
                                        <div>
                                          {{ broker.name }}
                                        </div>
                                      </div>

                                      <div class="flex-styles mt-2">
                                        <div class="signupWidth">
                                          {{lang.Description}}
                                        </div>
                                        <div>
                                          {{ broker.description }}
                                        </div>
                                      </div>

                                     <div class="flex-styles mt-2">
  <div class="signupWidth">{{ lang.Link }}</div>
  <div class="d-flex align-items-center">
    <!-- Status Icon with Tooltip -->
    <span
      [title]="broker.published ? 'Active form' : 'Inactive / Disabled form'"
      [ngClass]="{
        'text-success': broker.published,
        'text-danger': !broker.published
      }"
      class="me-1"
    >
      <i class="bi bi-circle-fill"></i>
    </span>

    <!-- Enrollment Link -->
    <a
      [href]="broker.published ? broker.link : 'javascript:void(0)'"
      [class.text-muted]="!broker.published"
      [style.pointerEvents]="broker.published ? 'auto' : 'none'"
      target="_blank"
    >
      Enrollment Link
    </a>

    <!-- Copy Button -->
    <button
      id="copyButton1"
      style="border: none"
      class="spanCopy1 btnSizes ms-2 ftsize12 cursor-pointer"
      (click)="copyToClipboard1(broker.link)"
      [disabled]="!broker.published"
      [title]="broker.published ? 'Copy link' : 'Link inactive'"
    >
      <img src="../../assets/img/copy.svg" class="widHigSvgIcon" />
    </button>
  </div>
</div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="controlCard1">
                                <div class="tranding-slider-control">
                                  <div class="swiper-button-prev2 ftsize20">
                                    <i class="fa fa-angle-left" (click)="leftClick()" id="swiper-button-prev2"></i>
                                  </div>

                                  <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                                  <div class="swiper-button-next2 ftsize20">
                                    <i class="fa fa-angle-right" (click)="rightClick()" id="swiper-button-next2"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                        <div class="text-center" *ngIf="brokerFormData?.length == 0">
                          {{lang.No_Data_Available}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2" >
              <div>
                <div class="_card paymentCard2 p-0">
                  <div class="_card_title ftsize12">
                    Resources
                    <button data-bs-toggle="modal" data-bs-target="#addResources" (click)="clearAdminForm()"
                      class="addgroupadmininfoemp">
                      <strong>+{{lang.Add}}</strong>
                    </button>
                  </div>
                  <div class="mt-2">
                      <section id="tranding" class="tranding-style">
                        <div class="swiper tranding-slider swiper-container">
                          <div class="swiper-wrapper">
                            <div class="swiper-slide tranding-slide" *ngIf="disclosuredisplaypdf !=null">
                              <div class="card _activecard p-0 pb-0">
                                <div class="card-header p-0" style="height: 28%">
                                  <img id="image" src="/assets/img/Group_contacts.png" style="
                                      width: 100%;
                                      height: 100%;
                                      object-fit: cover;
                                    " />
                                </div>
                                <div class="card-body py-2 px-1 groupContactsBgClr tileheight">
                                  <div class="ms-2">



                                    <div class="flex-styles1">
                                      <div>Disclosure Agreement</div>
                                      <!-- <div>{{booklet.description}}</div> -->

                                    <div class="">

                                      <i class="bi bi-eye-fill"  data-bs-toggle="modal"
                                      data-bs-target="#ViewDisclousreAggrement"
                                      data-bs-placement="top" id="viewing" (click)="viewDisclosure(disclosuredisplaypdf)"
                                      style="color: blueviolet; cursor: pointer" title="View"></i>
                                      &nbsp;
                                      <i class="bi bi-download"  id="viewing" (click)="downloadResource(disclosuredisplaypdf)"
                                      style="color: green; cursor: pointer" title="Download"></i>
                                     &nbsp;
                                      <i class="bi bi-pencil-square"  id="viewing" data-bs-toggle="modal"
                                      data-bs-target="#addDisclousreAggrement"  (click)="checkfile('Disclosure Agreement')" style="
                                        color: #1429a9;
                                        cursor: pointer;
                                      " title="Edit/Add"></i>
                                    &nbsp;
                                    <i class="bi bi-trash-fill redClr"  id="viewing" (click)="deleteResource(disclosuredisplaypdf,'Disclosure Agreement')"
                                      style="color: red; cursor: pointer" title="Delete"></i>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="swiper-slide tranding-slide" *ngIf="termsAndConditionspdf !=null">
                              <div class="card _activecard p-0 pb-0">
                                <div class="card-header p-0" style="height: 28%">
                                  <img id="image" src="/assets/img/Group_contacts.png" style="
                                      width: 100%;
                                      height: 100%;
                                      object-fit: cover;
                                    " />
                                </div>
                                <div class="card-body py-2 px-1 groupContactsBgClr tileheight">
                                  <div class="ms-2">



                                    <div class="flex-styles1">
                                      <div>Terms and Conditions</div>
                                      <!-- <div>{{booklet.description}}</div> -->

                                    <div class="">

                                      <i class="bi bi-eye-fill"  data-bs-toggle="modal"
                                      data-bs-target="#ViewDisclousreAggrement"
                                      data-bs-placement="top" id="viewing" (click)="viewDisclosure(termsAndConditionspdf)"
                                      style="color: blueviolet; cursor: pointer" title="View"></i>
                                      &nbsp;
                                      <i class="bi bi-download"  id="viewing" (click)="downloadResource(termsAndConditionspdf)"
                                      style="color: green; cursor: pointer" title="Download"></i>
                                     &nbsp;
                                      <i class="bi bi-pencil-square"  id="viewing" data-bs-toggle="modal"
                                      data-bs-target="#addTermsandConditions" (click)="checkfile('Terms And Conditions')" style="
                                        color: #1429a9;
                                        cursor: pointer;
                                      " title="Edit/Add"></i>
                                    &nbsp;
                                    <i class="bi bi-trash-fill redClr"  id="viewing" (click)="deleteResource(termsAndConditionspdf,'Terms and Conditions')"
                                      style="color: red; cursor: pointer" title="Delete"></i>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="swiper-slide tranding-slide" *ngIf="brokerlogo !=null">
                              <div class="card _activecard p-0 pb-0">
                                <div class="card-header p-0" style="height: 28%">
                                  <img id="image" src="/assets/img/Group_contacts.png" style="
                                      width: 100%;
                                      height: 100%;
                                      object-fit: cover;
                                    " />
                                </div>
                                <div class="card-body py-2 px-1 groupContactsBgClr tileheight">
                                  <div class="ms-2">



                                    <div class="flex-styles1">
                                      <div>Logo</div>
                                      <!-- <div>{{booklet.description}}</div> -->

                                    <div class="">

                                      <i class="bi bi-eye-fill"  data-bs-toggle="modal"
                                      data-bs-target="#ViewBrokerLogo"
                                      data-bs-placement="top" id="viewing" (click)="viewDisclosure(brokerlogo)"
                                      style="color: blueviolet; cursor: pointer" title="View"></i>
                                      &nbsp;
                                      <!-- <i class="bi bi-download"  id="viewing" (click)="downloadResource(brokerlogo)"
                                      style="color: green; cursor: pointer" title="Download"></i> -->
                                     &nbsp;
                                      <i class="bi bi-pencil-square"  id="viewing" data-bs-toggle="modal"
                                      data-bs-target="#addResourceLogo"  style="
                                        color: #1429a9;
                                        cursor: pointer;" title="Edit/Add"></i>
                                    &nbsp;
                                    <i class="bi bi-trash-fill redClr"  id="viewing" (click)="deleteResource(brokerlogo,'Logo')"
                                      style="color: red; cursor: pointer" title="Delete"></i>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="controlCard1" *ngIf="disclosuredisplaypdf!=null || termsAndConditionspdf !=null || brokerlogo!=null">
                            <div class="tranding-slider-control">
                              <div class="swiper-button-prev2 ftsize20">
                                <i class="fa fa-angle-left" id="swiper-button-prev2"></i>
                              </div>

                              <div id="paginationCount2" class="swiper-pagination ftsize14 mt-3"></div>
                              <div class="swiper-button-next2 ftsize20">
                                <i class="fa fa-angle-right" id="swiper-button-next2"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                    <div class="text-center" *ngIf="disclosuredisplaypdf==null && termsAndConditionspdf ==null && brokerlogo==null">
                      {{lang.No_Data_Available}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
                <div class="tiles col-12 col-md-3 ftsize12 pe-0 mt-2"></div>
              </div>

              <div class="mb-5"></div>

              <!-- Corporate Information -->
              <!-- <div class="row">
                <div class="ftsize12 mt-2">
                  <div class="card paymentCard p-0">
                    <div class="card-header ftsize12">
                      <a class>Corporate
                        Information&nbsp;&nbsp;<i
                          class="bi bi-info-circle"></i></a>
                    </div>
                    <div class="card-body ftsize12 ">
                      <div class="row">
                        <div class="col-sm-12">

                          <form class="onbordingform"
                            [formGroup]="clientregform">
                            <div class="row">

                            </div>
                            <div class="input-wrapper row">
                              <div class="form-group col-12 col-md-6">
                                <label for="Corporation"
                                  class="Corporation">Name of
                                  Corporation<span
                                    style="color: red">*</span></label>
                                <input type="text"
                                  class="form-control checking-field"
                                  id="nameofcorporation"
                                  placeholder="Name of Corporation"
                                  formControlName="corporationName"
                                  [(ngModel)]="CorpName"
                                  (blur)="checkNameExists()" />
                                <div
                                  *ngIf="client['corporationName'].touched && client['corporationName'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please
                                    enter corporation name</div>
                                  <div
                                    *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">
                                    Corporation name should be 3
                                    characters</div>
                                  <div
                                    *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">
                                    Corporation name must not exceed 70
                                    characters</div>
                                  <div
                                    *ngIf="client['corporationName'].errors &&client['corporationName'].errors['pattern']">
                                    Corporation name Shouldn't allow numbers,
                                    special
                                    characters and blank spaces
                                  </div>
                                </div>

                              </div>
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">Policy Start
                                  Date<span style="color: red">*</span></label>

                                <select class="form-control ftsize"
                                  id="planenrollmentdate"
                                  placeholder="Select"
                                  formControlName="PolicyStartDate"
                                  [(ngModel)]="policyStartDate">
                                  <option value label>Select</option>
                                  <option *ngFor="let name of enrollmentDates"
                                    [value]="name"
                                    [label]="name">
                                    {{ name }}
                                  </option>
                                </select>
                                <div
                                  *ngIf="client['PolicyStartDate'].touched && client['PolicyStartDate'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['PolicyStartDate'].errors && client['PolicyStartDate'].errors['required']">Please
                                    choose policy start date</div>
                                </div>
                              </div>

                              <div class="form-group col-12 col-md-3">
                                <label for="multiSelectProviance"
                                  class="Corporation">Provincial offices in
                                  Operation<span
                                    style="color: red">*</span></label>
                                <div class style="margin-top: -5px;">
                                  <ng-multiselect-dropdown class="ftsize"
                                    formControlName="multiSelectProviance"
                                    [placeholder]="'Select'"
                                    [settings]="dropdownSettings"
                                    [data]="configprovincereslist1"
                                    (onSelect)="multiSelectProvianceItemSelect($event)"
                                    (onSelectAll)="multiSelectProvianceSelectAll($event)"
                                    (onDeSelect)="multiSelectProvianceItemDeSelect($event)"
                                    (onDeSelectAll)="multiSelectProvianceItemDeSelectAll($event)"
                                    style="background-color: rgb(232, 234, 240);">
                                  </ng-multiselect-dropdown>
                                </div>
                                <div
                                  *ngIf="client['multiSelectProviance'].touched"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['multiSelectProviance'].errors &&
               client['multiSelectProviance'].errors['required']">
                                    Please select atleast one Province
                                  </div>
                                </div>
                              </div>

                            </div>
                            <div class="row">
                              <div class="form-group col-12 col-md-6">
                                <label for="Corporation"
                                  class="Corporation">Street
                                  Address<span
                                    style="color: red">*</span></label>

                                <input type="text"
                                  class="form-control checking-field"
                                  id="Street Address"
                                  placeholder="Street Address"
                                  style="text-transform: capitalize;"
                                  formControlName="streetAddress"
                                  [(ngModel)]="streetAddress" />
                                <div
                                  *ngIf="client['streetAddress'].touched && client['streetAddress'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['streetAddress'].errors && client['streetAddress'].errors['required']">Please
                                    enter street address</div>
                                </div>
                              </div>
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">Street Address
                                  Line 2</label>

                                <input type="text"
                                  class="form-control checking-field"
                                  style="text-transform: capitalize;"
                                  id="StreetAddreess2"
                                  placeholder="Street Address Line 2"
                                  [(ngModel)]="streetAddress2"
                                  formControlName="streetAddress2" />

                              </div>
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">Unit/Apt/Suite
                                  #</label>

                                <input type="text"
                                  class="form-control checking-field"
                                  style="text-transform: capitalize;" id="apt"
                                  placeholder="Unit/Apt/Suite #"
                                  [(ngModel)]="apt"
                                  formControlName="apt" />
                                <div
                                  *ngIf="client['apt'].touched && client['apt'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['apt'].errors && client['apt'].errors['aptexpression']">Please
                                    enter
                                    valid Unit/Apt/Suite number</div>
                                  <div
                                    *ngIf="client['apt'].errors && client['apt'].errors['maxlength']">Unit/Apt/Suite
                                    name must not
                                    exceed 10 characters</div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">City<span
                                    style="color: red">*</span></label>

                                <input type="text"
                                  class="form-control checking-field"
                                  id="city" placeholder="City"
                                  style="text-transform: capitalize;"
                                  formControlName="city"
                                  [(ngModel)]="city" />
                                <div
                                  *ngIf="client['city'].touched && client['city'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['city'].errors && client['city'].errors['required']">Please
                                    enter city</div>
                                </div>

                              </div>

                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">Country<span
                                    style="color: red">*</span></label>

                                <select class="form-control" id="country"
                                  placeholder="Country"
                                  formControlName="country"
                                  [(ngModel)]="country"
                                  (change)="getprovincelist($event)">
                                  <option value
                                    [disabled]="true">Select</option>
                                  <option *ngFor="let country of countryList"
                                    [value]="country.name">
                                    {{country.name}}
                                  </option>
                                </select>
                                <div
                                  *ngIf="client['country'].touched && client['country'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['country'].errors && client['country'].errors['required']">Please
                                    select country
                                  </div>
                                </div>

                              </div>

                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">{{stateLabel}}<span
                                    style="color: red">*</span></label>
                                <select class="form-control" id="Province"
                                  placeholder="Province"
                                  style="text-transform: capitalize;"
                                  formControlName="Province"
                                  (change)="provincelist($event.target.value)"
                                  [(ngModel)]="province">
                                  <option value>Select</option>

                                  <option
                                    *ngFor="let name of configprovincereslist"
                                    [value]="name.shortName">
                                    {{ name.shortName }}
                                  </option>
                                </select>

                                <div
                                  *ngIf="client['Province'].touched && client['Province'].invalid"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['Province'].errors && client['Province'].errors['required']">Please
                                    select
                                    province</div>
                                </div>
                              </div>
                              <div class="form-group col-12 col-md-3">
                                <label for="Corporation"
                                  class="Corporation">{{zipCodeLabel}}<span
                                    style="color: red">*</span></label>

                                <input type="text"
                                  class="form-control checking-field"
                                  id="postalcode" placeholder="{{zipCodeLabel}}"
                                  onkeyup="this.value = this.value.toUpperCase();"
                                  formControlName="postalCode"
                                  [(ngModel)]="postalCode"
                                  (input)="changeTextToUppercase('postalcode', $event)" />
                                <div *ngIf="client['postalCode'].touched"
                                  class="help-block text-danger">
                                  <div
                                    *ngIf="client['postalCode'].errors && client['postalCode'].errors['required']">Please
                                    enter
                                    {{zipCodeLabel}}</div>
                                  <div
                                    *ngIf="invalidpostalcodeprivince || client['postalCode'].touched &&client['postalCode'].hasError('invalidPostalCode')">
                                    Please enter valid {{zipCodeLabel}}</div>

                                </div>

                              </div>

                            </div>
                            <div class="row">
                              <div>
                                <button type="submit"
                                  class="btn btn-primary ftsize addgroupadmininfoemp"
                                  (click)="updateCorporateAddress()"><b>
                                    Update</b></button>
                              </div>
                            </div>
                          </form>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div> -->

              <!-- {{lang.Group_Contacts}} start -->
              <!-- <div class="row">
                <div class="ftsize12 mt-2">
                  <div class="card paymentCard p-0">
                    <div class="card-header ftsize12">
                      {{lang.Group_Contacts}} <button class="addgroupadmininfoemp"
                        (click)="basicModalOpen()"><strong>+&nbsp;Add
                          More</strong></button>
                    </div>
                    <div class="card-body ftsize12 ">
                      <div class="row">
                        <div class="col-sm-12">
                          <form class="plansform">
                            <div class="row">

                              <div class="row groupContactstileheight">
                                <div class="form-group col-12">
                                  <div
                                    style="overflow: auto; direction:ltr;  width: 100%;">
                                    <table align="left">
                                      <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Phone Number</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th></th>
                                      </tr>
                                      <tbody>
                                        <tr
                                          *ngFor="let admin of groupContacts; let i = index"
                                          [ngClass]="{'orange': i % 2 == 0, 'white': i % 2 != 0}">
                                          <td
                                            class="borderclr">{{admin.firstName}}</td>
                                          <td
                                            class="borderclr">{{admin.lastName}}</td>
                                          <td
                                            class="borderclr">{{admin.phoneNum}}</td>
                                          <td
                                            class="borderclr">{{admin.email}}</td>
                                          <td class="borderclr">
                                            <span
                                              *ngIf="admin.role=='CORPORATE_ACCOUNTANT'">Accountant</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_EXECUTIVE'">Executive</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_PLAN_ADMINISTRATOR'">Plan
                                              Administrator</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_ADMIN'">System
                                              Administrator</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_WELLNESS_CHAMPION'">Wellness
                                              Champion</span>
                                            <span
                                              *ngIf="admin.role=='CORPORATE_OTHERS'">{{
                                              admin.roleName }}</span>
                                            <span *ngIf="
                              admin.role !== 'CORPORATE_ACCOUNTANT' &&
                              admin.role !== 'CORPORATE_EXECUTIVE' &&
                              admin.role !== 'CORPORATE_PLAN_ADMINISTRATOR' &&
                              admin.role !== 'CORPORATE_ADMIN' &&
                              admin.role !== 'CORPORATE_WELLNESS_CHAMPION' &&
                              admin.role !== 'CORPORATE_OTHERS'">{{ admin.role
                                              }}</span>
                                          </td>
                                          <td
                                            style="text-align:right;display:flex; margin-top:0px;"
                                            class="borderclr">
                                            &nbsp;&nbsp;
                                            <i class="bi bi-pencil-square"
                                              data-bs-toggle="modal"
                                              data-bs-target="#basicModaledit"
                                              (click)="editadmin(admin,i)"
                                              style="color:#1429A9; cursor: pointer;"
                                              title="Edit"></i>
                                            &nbsp;&nbsp;
                                            <i class="bi bi-trash-fill redClr"
                                              (click)="deleteadmin(admin,i)"
                                              style="color:red; cursor: pointer"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              title="Delete"></i>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div> -->
              <!-- end {{lang.Group_Contacts}} -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</main>

<!-- *********************************Start Corp info popups -->
<!-- Add {{lang.Group_Contacts}} -->
<div class="modal fade" data-bs-backdrop="static" id="basicModal1" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Add_Group_Contact}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="hidegrpadmindetails()"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
              <!-- <div *ngIf="submittedadmin && grpcontact['firstName'].errors" class="invalid-feedback">
                <div *ngIf="grpcontact['firstName'].errors['required']">First Name is required</div>
                <div *ngIf="grpcontact['firstName'].errors['minlength']">
                  First Name must be at least 3 characters
                </div>
                <div *ngIf="grpcontact['firstName'].errors['maxlength']">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div> -->
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="phoneNum" placeholder={{lang.Phone_Number}}
                (change)="phoneFormatForGroupCont(adminform, 'phoneNum')" formControlName="phoneNum" />

              <div *ngIf="
                  grpcontact['phoneNum'].touched &&
                  grpcontact['phoneNum'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <!-- <div *ngIf="grpcontact['phoneNum'].errors && grpcontact['phoneNum'].errors['pattern']">Please enter valid phone number</div> -->
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>
              <select (change)="groupContactChange($event)" class="form-control" id="lengthofService"
                formControlName="role">
                <option value="" disabled>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
              </select>
              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_Role}}
                </div>
              </div>
            </div>
            <div class="form-group col-6" *ngIf="ShowOthers">
              <!-- <div> -->
              <label for="Corporation" class="Corporation">{{lang.Others}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="roleName" placeholder={{lang.Others}}
                formControlName="roleName" />
              <div *ngIf="
                  grpcontact['roleName'].touched &&
                  grpcontact['roleName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['roleName'].errors &&
                    grpcontact['roleName'].errors['required']
                  ">
                  {{lang.please_enter_role}}
                </div>

                <!-- </div> -->
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="closeButton" data-bs-dismiss="modal"
          (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" [disabled]="adminform.invalid"
          (click)="addadmin()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" data-bs-backdrop="static" id="addEoInfo" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Add_E_O_Information}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="eoform" (ngSubmit)="addeo()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}</label>

              <input type="text" class="form-control checking-field" id="InsuranceName" placeholder={{lang.Insurer_Name}}
                formControlName="insurerName" style="text-transform: capitalize" />

              <div *ngIf="eo['insurerName'].touched && eo['insurerName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                  {{lang.Please_enter_Insurance_name}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['minlength']
                  ">
                  {{lang.Insurer_name_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['maxlength']
                  ">
                  {{lang.Insurer_name_must_not_exceed_100_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Certificate}} #</label>
              <input type="text" class="form-control checking-field" id="certificatename" placeholder={{lang.Certificate}}
                formControlName="certificateNumber" />

              <div *ngIf="
                  eo['certificateNumber'].touched &&
                  eo['certificateNumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['certificateNumber'].errors &&
                    eo['certificateNumber'].errors['required']
                  ">
                  {{lang.Please_enter_Certificate_Name}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Policy}} #</label>

              <input type="text" class="form-control checking-field" id="PolicyNumber" placeholder={{lang.Policy}}
                formControlName="policyNumber" />

              <div *ngIf="eo['policyNumber'].touched && eo['policyNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['policyNumber'].errors &&
                    eo['policyNumber'].errors['required']
                  ">
                  {{lang.Please_enter_Policy_Number}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}</label>

              <input type="text" placeholder="Expiry Date" class="form-control" formControlName="expiryDate"
                (onShown)="disableScrolling()" (onHidden)="enableScrolling()" [minDate]="todayDate" bsDatepicker
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="eo['expiryDate'].touched && eo['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['expiryDate'].errors &&
                    eo['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="closeButton" data-bs-dismiss="modal"
          (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" [disabled]="eoform.invalid" (click)="addeo()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" data-bs-backdrop="static" id="addLicenseModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Add_Broker_License}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="hidelicensedetails()"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicense()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNumber" style="text-transform: capitalize" />

              <div *ngIf="f['licenseNumber'].touched && f['licenseNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverage" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                (change)="insuranceprovincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  {{lang.Please_select_province}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

              <input type="text" placeholder="Expiry Date" class="form-control" formControlName="expiryDate"
                [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"/>
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder={{lang.Reminder_Days}}
                (keypress)="numberOnly($event)" formControlName="remainder_days" style="text-transform: capitalize" />

              <div *ngIf="
                  f['remainder_days'].touched && f['remainder_days'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['remainder_days'].errors &&
                    f['remainder_days'].errors['required']
                  ">
                  {{lang.Please_enter_reminder_days}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="closeButton" data-bs-dismiss="modal"
          (click)="hidelicensedetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" [disabled]="licenseform.invalid"
          (click)="addlicense()">
          {{lang.Add}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" data-bs-backdrop="static" id="licenseedit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Edit_License}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="hideaddlicenseform()"></i>
        </div>
      </div>

      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="editLicenseSubmit()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNumber" [(ngModel)]="editbrokerlicensenumber"
                style="text-transform: capitalize" />

              <div *ngIf="f['licenseNumber'].touched && f['licenseNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNumber'].errors &&
                    f['licenseNumber'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage"
                [(ngModel)]="editbrokerlicensecoverage">
                <option value="" disabled>{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverage" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                [(ngModel)]="editbrokerlicensestate" (change)="insuranceprovincelist($event)">
                <option value="" disabled>Select</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  {{lang.Please_select_province}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

              <input type="text" placeholder="Expiry Date" class="form-control" formControlName="expiryDate"
                [minDate]="todayDate" [(ngModel)]="editbrokerlicenseexpirydate" bsDatepicker
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"/>
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder="Reminder Days"
                [(ngModel)]="editbrokerlicenseexpiryremainder" (keypress)="numberOnly($event)"
                formControlName="remainder_days" style="text-transform: capitalize" />

              <!-- <div
                *ngIf="
                  f['remainder_days'].touched && f['remainder_days'].invalid
                "
                class="help-block text-danger"
              >
                <div
                  *ngIf="
                    f['remainder_days'].errors &&
                    f['remainder_days'].errors['required']
                  "
                >
                  {{lang.Please_enter_reminder_days}}
                </div>
              </div> -->
              <div *ngIf="
                  licenseform.get('remainder_days').invalid &&
                  licenseform.get('remainder_days').touched
                ">
                <div *ngIf="licenseform.get('remainder_days').hasError('required')">
                  <div class="help-block text-danger">
                    {{lang.Please_enter_reminder_email_days}}
                  </div>
                </div>
                <div *ngIf="
                    licenseform
                      .get('remainder_days')
                      .hasError('maxDaysExceeded')
                  ">
                  <div class="help-block text-danger">
                    <!-- Reminder days must be less than exceed 180. -->
                    <!-- {{lang.Currently_remainder_days_are_limited_to_maximum_of_days}} -->
                    Currently reminder days are limited to maximum of days
                    {{ maxRemainderDays }} {{lang.days}}.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hideaddlicenseform()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editLicenseSubmit()">
          {{lang.Save}}
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Add {{lang.Group_Contacts}} -->
<div class="modal fade" data-bs-backdrop="static" id="advisorModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Edit_Advisor_Information}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="brokerregform">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Name_of_Broker}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="nameofcorporation" [(ngModel)]="brokerinfoName"
                placeholder={{lang.Name_of_Broker}} style="text-transform: capitalize" disabled
                formControlName="brokersName" />

              <div *ngIf="
                  broker['brokersName'].touched && broker['brokersName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    broker['brokersName'].errors &&
                    broker['brokersName'].errors['required']
                  ">
                  {{lang.Please_enter_broker_name}}
                </div>
                <div *ngIf="
                    broker['brokersName'].errors &&
                    broker['brokersName'].errors['minlength']
                  ">
                  {{lang.Broker_name_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    broker['brokersName'].errors &&
                    broker['brokersName'].errors['maxlength']
                  ">
                  {{lang.Broker_name_must_not_exceed_255_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

              <select class="form-control"  id="brokerType" [ngModel]="brokerinfobrokerType"
                placeholder="Select" (change)="brokertype(brokername.value)" #brokername formControlName="brokerType">
                <option value="" disbaled>Select</option>

                <option *ngFor="let name of brokerType" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>
              <div *ngIf="
                  broker['brokerType'].touched && broker['brokerType'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    broker['brokerType'].errors &&
                    broker['brokerType'].errors['required']
                  ">
                  {{lang.Please_select_broker_type}}
                </div>
                <!-- <div *ngIf="broker['brokersName'].errors && broker['brokersName'].errors['minlength']">Broker name should be 3 character</div>
              <div *ngIf="broker['brokersName'].errors && broker['brokersName'].errors['maxlength']">Broker name must not exceed 30 characters</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Phone_Number}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="primaryPhone" placeholder={{lang.Phone_Number}}
                [(ngModel)]="primaryPhone" formControlName="primaryPhone" (change)="
                  phoneFormatForGroupCont(brokerregform, 'primaryPhone')
                " />

              <div *ngIf="
                  broker['primaryPhone'].touched &&
                  broker['primaryPhone'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    broker['primaryPhone'].errors &&
                    broker['primaryPhone'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <div *ngIf="
                    broker['primaryPhone'].errors &&
                    broker['primaryPhone'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    broker['primaryPhone'].errors &&
                    broker['primaryPhone'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>

            <div class="form-group col-6" *ngIf="showBusinessnumber">
              <label for="Corporation" class="Corporation">{{lang.Business_Number}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="businessnumber" placeholder="{{lang.Business_Number}}"
                formControlName="businessnumber" />
              <div *ngIf="
                  broker['businessnumber'].touched &&
                  broker['businessnumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    broker['businessnumber'].errors &&
                    broker['businessnumber'].errors['required']
                  ">
                 {{lang.Please_enter_business_number}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Secondary_Phone}}</label>

              <input type="text" class="form-control checking-field" id="secondaryPhone" placeholder={{lang.Secondary_Phone}}
                [(ngModel)]="secondaryPhone" formControlName="secondaryPhone" (change)="
                  phoneFormatForGroupCont(brokerregform, 'secondaryPhone')
                " />

              <div *ngIf="
                  broker['secondaryPhone'].touched &&
                  broker['secondaryPhone'].invalid
                " class="help-block text-danger">
                <!-- <div *ngIf="broker['primaryPhone'].errors && broker['primaryPhone'].errors['required']">{{lang.Please_enter_phone_number}}</div> -->
                <div *ngIf="
                    broker['secondaryPhone'].errors &&
                    broker['secondaryPhone'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    broker['secondaryPhone'].errors &&
                    broker['secondaryPhone'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder="Primary Email"
                [(ngModel)]="primaryEmail" formControlName="primaryEmail" />
              <div *ngIf="
                  broker['primaryEmail'].touched &&
                  broker['primaryEmail'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    broker['primaryEmail'].errors &&
                    broker['primaryEmail'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    broker['primaryEmail'].errors &&
                    broker['primaryEmail'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Secondary_Email}}</label>
              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Secondary_Email}}
                [(ngModel)]="secondaryEmail" formControlName="secondaryEmail" />

              <div *ngIf="
                  broker['secondaryEmail'].touched &&
                  broker['secondaryEmail'].invalid
                " class="help-block text-danger">
                <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">{{lang.Please_enter_email}}</div> -->
                <div *ngIf="
                    broker['secondaryEmail'].errors &&
                    broker['secondaryEmail'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Third_Email}}</label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Third_Email}}
                formControlName="thirdEmail" [(ngModel)]="thirdEmail" />

              <div *ngIf="
                  broker['thirdEmail'].touched && broker['thirdEmail'].invalid
                " class="help-block text-danger">
                <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">{{lang.Please_enter_email}}</div> -->
                <div *ngIf="
                    broker['thirdEmail'].errors &&
                    broker['thirdEmail'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Street_Address}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="Street Address" placeholder={{lang.Street_Address}}
                [(ngModel)]="streetAddressline1" formControlName="streetAddress" />
              <div *ngIf="
                  broker['streetAddress'].touched &&
                  broker['streetAddress'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    broker['streetAddress'].errors &&
                    broker['streetAddress'].errors['required']
                  ">
                  {{lang.Please_enter_street_address_name}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Street_Address_Line_2}}</label>

              <input type="text" class="form-control checking-field" id="StreetAddreess2"
                [(ngModel)]="streetAddressline2" placeholder="Street Address Line 2" formControlName="streetAddress2" />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.City}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="city" [(ngModel)]="city" placeholder={{lang.City}}
                style="text-transform: capitalize" formControlName="city" />

              <div *ngIf="broker['city'].touched && broker['city'].invalid" class="help-block text-danger">
                <div *ngIf="
                    broker['city'].errors && broker['city'].errors['required']
                  ">
                  {{lang.Please_enter_city_name}}
                </div>
                <div *ngIf="
                    broker['city'].errors && broker['city'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_city_name}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Country}} <span style="color: red">*</span></label>

              <select class="form-control" id="country" placeholder="Country" formControlName="country"
                [ngModel]="country" (change)="changeCountry()">
                <option value="" disabled>{{lang.Select}}</option>
                <option value="Canada" selected>Canada</option>
                <!-- <option value="usa">USA</option> -->

                <!-- <option
                    *ngFor="let name of configprovinceres"
                    [value]="name.shortName"
                  >
                    {{ name.shortName }}
                  </option> -->
              </select>
              <div *ngIf="broker['country'].touched && broker['country'].invalid" class="help-block text-danger">
                <div *ngIf="
                    broker['country'].errors &&
                    broker['country'].errors['required']
                  ">
                  {{lang.Please_select_country}}
                </div>
                <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
                    <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Province }}<span style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Province" [(ngModel)]="state"
                formControlName="Province" (change)="provincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>
              <div *ngIf="broker['Province'].touched && broker['Province'].invalid" class="help-block text-danger">
                <div *ngIf="
                    broker['Province'].errors &&
                    broker['Province'].errors['required']
                  ">
                  {{lang.Please_select_province}}
                </div>
                <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
          <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation2">{{lang.Postal_Code}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" [(ngModel)]="postalCode" id="postalcode"
                placeholder={{lang.Postal_Code}} onkeyup="this.value = this.value.toUpperCase();" formControlName="postalCode"
                (input)="changeTextToUppercase('postalcode', $event)" />
              <div *ngIf="broker['postalCode'].touched" class="help-block text-danger">
                <div *ngIf="
                    broker['postalCode'].errors &&
                    broker['postalCode'].errors['required']
                  ">
                  {{lang.Please_enter_postal_code}}
                </div>
                <div *ngIf="
                    invalidpostalcodeprivince ||
                    (broker['postalCode'].touched &&
                      broker['postalCode'].hasError('invalidPostalCode'))
                  ">
                  {{lang.Please_enter_valid_postal_code}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" id="closeModalDetails" data-bs-dismiss="modal"
          (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" id="submitButton" (click)="submitbasicInfo()">
          {{lang.Update}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" data-bs-backdrop="static" id="salesTrackingEdit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Edit_Sales_tracking_code}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="closeEditSalesTrackingCodes()"></i>
        </div>
      </div>
      <div class="modal-body">
        <div class="mx-2 row">
          <div class="col-5">{{lang.Sales_Tracking_Code}}</div>
          <div class="col-5 salecode px-1 py-1">{{ salesTrackingCode }}</div>
        </div>
        <div class="row salescracking mt-2 mx-2">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>{{lang.Broker}}</th>
                <th>{{lang.Percentage}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dynamic of brokersalesCodes; let i = index">
                <td style="margin-right: 10px">
                  <select class="form-control select2" id="parentidrole" placeholder="Select"
                    name="{{ dynamic.brokerId }}" [(ngModel)]="dynamic.brokerId" [ngModelOptions]="{ standalone: true }"
                    data-live-search="true">
                    <option value="" label="" disabled>{{lang.Select}}</option>
                    <option *ngFor="let broker of allBrokers" [value]="broker.id">
                      {{ broker.name }}-{{ broker.brokerType }}-{{
                      broker.salesTrackingCode
                      }}
                    </option>
                  </select>
                </td>
                <td>
                  <input class="form-control" name="{{ dynamic.percentage }}" [(ngModel)]="dynamic.percentage"
                    [ngModelOptions]="{ standalone: true }" type="number" maxlength="3" placeholder="" />
                </td>
                <td>
                  <button class="fa fa-trash-o deletetier" style="cursor: pointer"
                    (click)="deleteRow(i, dynamic)"></button>
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
          <div class="form-group text-end p-0">
            <button class="btn btn-primary addgroupadmininfo" type="button" (click)="addRow()">
              {{lang.Add_More}}
            </button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" data-bs-dismiss="modal" (click)="closeEditSalesTrackingCodes()">
          {{lang.Close}}
        </button>
        <button type="button" class="saveAndNext" (click)="saveEditSalesTrackingCodes()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" data-bs-backdrop="static" id="basicModaleditEO" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Edit_E_O_Details}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="hideaddlicenseform()"></i>
        </div>
      </div>

      <div class="modal-body">
        <form class="onbordingform" [formGroup]="eoform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="insurerName" placeholder="Number"
                formControlName="insurerName" [(ngModel)]="editEOinsurerName" style="text-transform: capitalize" />

              <div *ngIf="eo['insurerName'].touched && eo['insurerName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                  {{lang.Please_enter_Insurance_name}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['minlength']
                  ">
                  {{lang.Insurer_name_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['maxlength']
                  ">
                  {{lang.Insurer_name_must_not_exceed_100_characters}}
                </div>
                <!-- <div *ngIf="broker['brokersName'].errors && broker['brokersName'].errors['minlength']">{{lang.Broker_name_must_be_atleast_3_characters}}</div>
                        <div *ngIf="broker['brokersName'].errors && broker['brokersName'].errors['maxlength']">Broker name must not exceed 30 characters</div> -->
              </div>
            </div>

            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Certificate}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="certificateNumber"
                placeholder={{lang.Certificate}}  formControlName="certificateNumber" [(ngModel)]="editEOcertificate"
                style="text-transform: capitalize" />

              <div *ngIf="
                  eo['certificateNumber'].touched &&
                  eo['certificateNumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['certificateNumber'].errors &&
                    eo['certificateNumber'].errors['required']
                  ">
                  {{lang.Please_enter_Certificate_number}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Policy}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="policyNumber" placeholder={{lang.Policy}}
                formControlName="policyNumber" [(ngModel)]="editEOpolicy" style="text-transform: capitalize" />

              <div *ngIf="eo['policyNumber'].touched && eo['policyNumber'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['policyNumber'].errors &&
                    eo['policyNumber'].errors['required']
                  ">
                  {{lang.Please_enter_Policy_Number}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

              <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                [minDate]="todayDate" [(ngModel)]="editEOExpiryDate" bsDatepicker
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="eo['expiryDate'].touched && eo['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['expiryDate'].errors &&
                    eo['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" data-bs-dismiss="modal" (click)="closeEditSalesTrackingCodes()">
          {{lang.Close}}
        </button>
        <button type="button" class="saveAndNext" (click)="editeoinfosumbit()">
          {{lang.Save}}
        </button>
      </div>

    </div>
  </div>
</div>


<div id="roeAgreement" class="modal fade viewModal" role="dialog" aria-labelledby="modal-label" style="display: none"
  data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" id="heightWidthModal2">
    <div class="modal-content" id="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.ROE_Agreement}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-4">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>

      <div class="modal-body" id="modal-body1">
        <pdf-viewer *ngIf="true" id="pdf-viewer" [src]="employeeRoeURL" [render-text]="true"
          [original-size]="false"></pdf-viewer>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
      </div>
      <!-- <div class="modal-footer py-2">
              <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" id="updateButton" (click)="closepadinfo()"><b>{{lang.close_cp}}</b></button>
          </div> -->
    </div>
  </div>
</div>

<div class="modal fade" data-bs-backdrop="static" id="addResources" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 850px; margin-left: -100px">
      <div class="modal-header">
        <h6 class="modal-title">Add</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="form-group col-6 ">
            <label for="Corporation" class="Corporation">Select Resource Type<span style="color: red">*</span></label>

            <select class="form-control select2" id="parentidrole" placeholder="Select"
               data-live-search="true" (change)="getResourceEvent($event)" [(ngModel)]="resourceFileuplaod">
              <option value="" label="" disabled selected>{{lang.Select}}</option>
              <option value="logo" label="">Logo</option>
              <option value="disclosureAgreement" label="">Disclosure Agreement</option>
              <option value="TermsandConditions" label="">Terms And Conditions</option>
            </select>


          </div>
          <div class="uploadCorporateLogodisclosure" *ngIf="showresourcefile">
            <!-- <label style="float:right;color:red"  title="Delete logo" *ngIf="uploadlogoafter" (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill" ></i></label> -->

            <label for="Disclosure" class="Disclosure">
              <span *ngIf="showdisclosureaggrement">
                <p style="font-size: 12px">
                  <!-- {{lang.Click_to_upload_Disclosure_Agreement}} -->
                  Click to upload {{getResourcesFile}}

                </p>
              </span>

              <!-- <button (click)="openPdf()">hi</button> -->
              <img [src]="imageDisclosure" style="max-height: 50px" data-bs-target="#disclosure" />
            </label>
            <input id="Disclosure" type="file" style="display: none" accept=".pdf,.doc"
              formControlName="disclosureAgreement" (change)="uploadadmindisclosure($event)" />

            <!-- <input id="adminlogo1" type="file" accept="image/*" style="display: none;" formControlName="logo" (change)="uploadadminlogo1($event)"> -->
          </div>
          <div class="text-center" *ngIf="!showdisclosureaggrement" (click)="openPdf()">
            <p class="text-primary text-decoration-underline  text-center p-0 pb-1 px-1 " title={{disclosureAgg}}><u
                style="font-size:12px;cursor:pointer">{{ disclosureAgg.substring(0, 10)
                + '...' +
                disclosureAgg.slice(-4)}}</u></p>
          </div>



      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
        (click)="closePopup('addResources')">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="addform()">
          {{lang.Save}}
        </button> -->
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>



<div class="modal fade" data-bs-backdrop="static" id="addResourceLogo" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 850px; margin-left: -100px">
      <div class="modal-header">
        <h6 class="modal-title">Add</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="form-group col-6">
          <h6 class="admintitle">
            Logo&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
          </h6>
          <!-- <label   for="adminlogo" class="adminlogo1" *ngIf="uploadlogoafter"><strong>&nbsp;Update</strong></label> -->

          <div class="uploadCorporateLogodisclosure">
            <!-- <label style="float:right;color:red"  title="Delete logo" *ngIf="uploadlogoafter" (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill" ></i></label> -->

            <label for="adminlogo" class="adminlogo">
              <span *ngIf="showimagelogo">
                <p style="font-size: 12px">
                  Click to upload logo max 300*100px .png or .jpg
                  <!-- {{lang.Click_to_upload_LOGO_Max_300x100_px_png_jpg}} -->
                  <!-- Click to upload
                  <br />
                  LOGO
                  <br />
                  Max. 300x100 px .png,.jpg -->
                </p>
              </span>
              <img [src]="imagedisplay" style="max-height: 50px; max-width: 100px" />
            </label>
            <input id="adminlogo" type="file" accept="image/*" style="display: none"
              (change)="uploadadminlogo($event)" />

            <!-- <input id="adminlogo1" type="file" accept="image/*" style="display: none;" formControlName="logo" (change)="uploadadminlogo1($event)"> -->
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
        (click)="closePopup('addResourceLogo')">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="addform()">
          {{lang.Save}}
        </button> -->
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" data-bs-backdrop="static" id="addDisclousreAggrement" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 850px; margin-left: -100px">
      <div class="modal-header">
        <h6 class="modal-title">Add</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="form-group col-6 ">
          <h6 class="admintitle">

            Disclosure Agreement&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
          </h6>
          <div class="uploadCorporateLogodisclosure ">
            <!-- <label style="float:right;color:red"  title="Delete logo" *ngIf="uploadlogoafter" (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill" ></i></label> -->

            <label for="Disclosure" class="Disclosure">
              <span *ngIf="showdisclosureaggrement">
                <p style="font-size: 12px">
                  <!-- {{lang.Click_to_upload_Disclosure_Agreement}} -->
                  Click to upload Disclosure Agreement

                </p>
              </span>

              <!-- <button (click)="openPdf()">hi</button> -->
              <img [src]="imageDisclosure" style="max-height: 50px" data-bs-target="#disclosure" />
            </label>
            <input id="Disclosure" type="file" style="display: none" accept=".pdf,.doc"
              formControlName="disclosureAgreement" (change)="uploadadmindisclosure($event)" />

            <!-- <input id="adminlogo1" type="file" accept="image/*" style="display: none;" formControlName="logo" (change)="uploadadminlogo1($event)"> -->
          </div>
          <div class="text-center" *ngIf="!showdisclosureaggrement" (click)="openPdf()">
            <p class="text-primary text-decoration-underline  text-center p-0 pb-1 px-1 " title={{disclosureAgg}}><u
                style="font-size:12px;cursor:pointer">{{ disclosureAgg.substring(0, 10)
                + '...' +
                disclosureAgg.slice(-4)}}</u></p>
          </div>

          <!-- <div *ngIf="
            broker['disclosureAgreement'].touched &&
            broker['disclosureAgreement'].invalid
          " class="help-block text-danger">
            <div *ngIf="
              broker['disclosureAgreement'].errors &&
              broker['disclosureAgreement'].errors['required']
            ">
             {{lang.Please_upload_disclosure_agreement}}
            </div>
          </div> -->
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
        (click)="closePopup('addDisclousreAggrement')">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="addform()">
          {{lang.Save}}
        </button> -->
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" data-bs-backdrop="static" id="addTermsandConditions" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 850px; margin-left: -100px">
      <div class="modal-header">
        <h6 class="modal-title">Add</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="form-group col-6 ">
          <h6 class="admintitle">

            Terms and Conditions&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
          </h6>
          <div class="uploadCorporateLogodisclosure ">
            <!-- <label style="float:right;color:red"  title="Delete logo" *ngIf="uploadlogoafter" (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill" ></i></label> -->

            <label for="Disclosure" class="Disclosure">
              <span *ngIf="showdisclosureaggrement">
                <p style="font-size: 12px">
                  <!-- {{lang.Click_to_upload_Disclosure_Agreement}} -->
                  Click to upload Terms and Conditions

                </p>
              </span>

              <!-- <button (click)="openPdf()">hi</button> -->
              <img [src]="imageDisclosure" style="max-height: 50px" data-bs-target="#disclosure" />
            </label>
            <input id="Disclosure" type="file" style="display: none" accept=".pdf,.doc"
              formControlName="disclosureAgreement" (change)="uploadadmindisclosure($event)" />

            <!-- <input id="adminlogo1" type="file" accept="image/*" style="display: none;" formControlName="logo" (change)="uploadadminlogo1($event)"> -->
          </div>
          <div class="text-center" *ngIf="!showdisclosureaggrement" (click)="openPdf()">
            <p class="text-primary text-decoration-underline  text-center p-0 pb-1 px-1 " title={{disclosureAgg}}><u
                style="font-size:12px;cursor:pointer">{{ disclosureAgg.substring(0, 10)
                + '...' +
                disclosureAgg.slice(-4)}}</u></p>
          </div>

          <!-- <div *ngIf="
            broker['disclosureAgreement'].touched &&
            broker['disclosureAgreement'].invalid
          " class="help-block text-danger">
            <div *ngIf="
              broker['disclosureAgreement'].errors &&
              broker['disclosureAgreement'].errors['required']
            ">
             {{lang.Please_upload_disclosure_agreement}}
            </div>
          </div> -->
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
        (click)="closePopup('addTermsandConditions')">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="addform()">
          {{lang.Save}}
        </button> -->
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" data-bs-backdrop="static" id="editDisclousreAggrement" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 850px; margin-left: -100px">
      <div class="modal-header">
        <h6 class="modal-title">Edit</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="form-group col-6 ">
          <h6 class="admintitle">

            Disclosure Agreement&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
          </h6>
          <div class="uploadCorporateLogodisclosure ">
            <!-- <label style="float:right;color:red"  title="Delete logo" *ngIf="uploadlogoafter" (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill" ></i></label> -->

            <label for="Disclosure" class="Disclosure">
              <span *ngIf="showdisclosureaggrement">
                <p style="font-size: 12px">
                  <!-- {{lang.Click_to_upload_Disclosure_Agreement}} -->
                  Click to upload Disclosure Agreement

                </p>
              </span>

              <!-- <button (click)="openPdf()">hi</button> -->
              <img [src]="imageDisclosure" style="max-height: 50px" data-bs-target="#disclosure" />
            </label>
            <input id="Disclosure" type="file" style="display: none" accept=".pdf,.doc"
              formControlName="disclosureAgreement" (change)="uploadadmindisclosure($event)" />

            <!-- <input id="adminlogo1" type="file" accept="image/*" style="display: none;" formControlName="logo" (change)="uploadadminlogo1($event)"> -->
          </div>
          <div class="text-center" *ngIf="!showdisclosureaggrement" (click)="openPdf()">
            <p class="text-primary text-decoration-underline  text-center p-0 pb-1 px-1 " title={{disclosureAgg}}><u
                style="font-size:12px;cursor:pointer">{{ disclosureAgg.substring(0, 10)
                + '...' +
                disclosureAgg.slice(-4)}}</u></p>
          </div>

          <!-- <div *ngIf="
            broker['disclosureAgreement'].touched &&
            broker['disclosureAgreement'].invalid
          " class="help-block text-danger">
            <div *ngIf="
              broker['disclosureAgreement'].errors &&
              broker['disclosureAgreement'].errors['required']
            ">
             {{lang.Please_upload_disclosure_agreement}}
            </div>
          </div> -->
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
        (click)="closePopup('editDisclousreAggrement')">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="addform()">
          {{lang.Save}}
        </button> -->
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" data-bs-backdrop="static" id="ViewDisclousreAggrement" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 850px; margin-left: -100px">
      <div class="modal-header">
        <h6 class="modal-title">View</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <pdf-viewer *ngIf=true id="pdf-viewer" [src]="disclosuredisplaypdf1" [render-text]="true"
        [original-size]="false"></pdf-viewer>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
        (click)="closePopup('ViewDisclousreAggrement')">
          {{lang.Close}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal fade" data-bs-backdrop="static" id="ViewBrokerLogo" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 850px; margin-left: -100px">
      <div class="modal-header">
        <h6 class="modal-title">View</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <img [src]="disclosuredisplaypdf1" style="max-height: 50px; max-width: 100px" />

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
        (click)="closePopup('ViewBrokerLogo')">
          {{lang.Close}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="disclosure">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">
        <!-- <div class="col-1">
                  <i class="fa fa-info-circle dependentchildinfo text-white" aria-hidden="true"></i>
                </div> -->
        <div class="col-10 text-white text-center">{{getResourcesFile}}</div>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>

      </div>
      <div class="model-body ms-3 mt-2">
        <pdf-viewer *ngIf=true id="pdf-viewer" [src]="imagedisplaypdf" [render-text]="true"
          [original-size]="false"></pdf-viewer>
      </div>
      <div class="modal-footer">
        <button class="btn" style="font-size: 14px; border-radius: 5px" data-bs-dismiss="modal"
          (click)="closePopup('disclosure')">
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" data-bs-backdrop="static" id="addFormDetails" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 85vw;margin-left: -23vw;top: -3vh;" *ngIf="showaddplans">
      <div class="modal-header">
        <h6 class="modal-title">
          <!-- {{lang.Add_Signup_Form}} -->
          Add Enrollment Form
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="formCreation" style="height: 75vh; overflow-y: auto; overflow-x: hidden;">
          <div class="input-wrapper row">
            <!-- <div class="form-group col-4">
              <label for="Corporation" class="Corporation">Type<span style="color: red">*</span></label>
              <select class="form-control" id="Signupformtype" placeholder="Select" formControlName="Signupformtype"
                (change)="selectFormname($event)">
                <option value="" disabled>Select</option>
                <option *ngFor="let name of formType" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  form['Signupformtype'].touched &&
                  form['Signupformtype'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['Signupformtype'].errors &&
                    form['Signupformtype'].errors['required']
                  ">
                  Please select type
                </div>
              </div>
            </div> -->
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formName" placeholder={{lang.Title}}
                formControlName="formName" style="text-transform: capitalize" />

              <div *ngIf="form['formName'].touched && form['formName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    form['formName'].errors &&
                    form['formName'].errors['required']
                  ">
                  {{lang.Please_enter_form_title}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formDescription" placeholder={{lang.Description}}
                formControlName="formDescription" style="text-transform: capitalize" />

              <div *ngIf="
                  form['formDescription'].touched &&
                  form['formDescription'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['formDescription'].errors &&
                    form['formDescription'].errors['required']
                  ">
                  {{lang.Please_enter_form_description}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Logo}}</label>
              <input type="file" class="form-control checking-field" id="formlogo" placeholder="logo"
                formControlName="formlogo" (change)="uploadadminFormlogo($event)" />

              <div *ngIf="form['formlogo'].touched && form['formlogo'].invalid" class="help-block text-danger">
                <div *ngIf="
                    form['formlogo'].errors &&
                    form['formlogo'].errors['required']
                  ">
                  {{lang.Please_choose_form_logo}}
                </div>
              </div>
            </div>
          </div>

          <app-common-plans
           #advisorAdd
           [isAdvisor]="true"
           [viewPlan]="false"
           [advisorPackages]="productsArray"
           [allplansArray]="allplansArray"
           (submitTriggered)="addform()"
           [editFormPricingOptions]=""
           [selectedPlanLevels]="[]"
           >
           </app-common-plans>

          <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar" style="
              font-size: 12px;
              width: 100%;
              max-height: 350px;
              overflow-y: scroll;
            " *ngIf="showPlans && false">
            <div *ngFor="let product of productsArray; let i = index" class="mt-2">
              <div class="display-center">
                <div class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                  style="width: 430px" [ngStyle]="{
                    'background-color': product.published
                      ? '#515151'
                      : '#dc3545'
                  }">
                  <span class="my-auto col-1">
                    <input type="checkbox" id="package{{ product.id }}" [disabled]="
                        allplansArray[product.name]?.disabled === true
                      " [checked]="
                        allplansArray[product.name]?.packageCheckbox === true
                      " (change)="
                        toggleAllPlans(product.name, product.id, $event)
                      " />
                  </span>
                  <div class="my-auto mb-1 col-10 text-center">
                    <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                        *ngIf="!product.published && role === 'ADMINISTRATOR'" class="bi bi-info-circle text-light"
                        title="Unpublished"></i></span>
                  </div>
                  <div *ngIf="role === 'ADMINISTRATOR'" title="{{
                      getTextForTooltip1(product.published, product.restrict)
                    }}" [ngStyle]="{
                      'border-color': getColorForPlans1(
                        product.published,
                        product.restrict
                      )
                    }" class="outer my-auto ms-3 col-2" data-bs-toggle="">
                    <span class="inner" [ngStyle]="{
                        background: getColorForPlans1(
                          product.published,
                          product.restrict
                        )
                      }"></span>
                  </div>
                </div>
              </div>

              <div class="display-center mt-3 mb-4 flex-wrap">
                <div *ngFor="
                    let plans of product.parents | keyvalue;
                    let k = index
                  ">
                  <div
                    class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                    *ngIf="isParentsGreaterThanOne(product.parents)" style="background-color: #515151; width: 210px">
                    <span class="my-auto col-1">
                      <input type="checkbox" [disabled]="
                          allplansArray[product.name] && allplansArray[product.name][plans.key]?.disabled ===
                          true
                        " [checked]="
                        allplansArray[product.name] && allplansArray[product.name][plans.key]?.checked ===
                          true
                        " (change)="
                          planKeyCheckbox(
                            product.name,
                            plans.key,
                            plans.value[0].parentId,
                            $event
                          )
                        " />
                    </span>
                    <span class="my-auto mb-1 col-9 text-center">{{
                      plans.key
                      }}</span>
                  </div>
                  <div [ngClass]="{
                      'display-center': !isParentsGreaterThanOne(
                        product.parents
                      ),
                      'flex-wrap': !isParentsGreaterThanOne(product.parents)
                    }">
                    <div *ngFor="let plan of plans.value">
                      <div [style.background-color]="
                          plan.backgroundColor
                            ? plan.backgroundColor
                            : '#5E152E'
                        "
                        class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex align-items-center gap-1 row py-1 rounded"
                        style="width: 210px">
                        <!-- *ngIf="plan.parentId != null" -->
                        <div class="my-auto col-1">
                          <input type="checkbox" id="planCheckbox{{ plan.id }}" [checked]="
                          allplansArray[product.name] && allplansArray[product.name][plan.name]
                                .planCheckbox === true
                            " [disabled]="
                            allplansArray[product.name] && allplansArray[product.name][plan.name]
                                ?.disabled === true
                            " (change)="
                              planCheckbox(
                                product.name,
                                plans.key,
                                plans.value[0].parentId,
                                plan.name,
                                plan.id,
                                $event,
                                plan.disallowedPlanLevels,
                                product.allowMultiple
                              )
                            " />
                        </div>
                        <div class="my-auto col-9 mb-1" style="font-size: 12px">
                          <span >{{ plan.name }}</span>
                        </div>
                        <div *ngIf="role === 'ADMINISTRATOR'" title="{{
                            getTextForTooltip(
                              plan.published.data[0],
                              plan.restrict
                            )
                          }}" [ngStyle]="{
                            'border-color': getColorForPlans(
                              plan.published.data[0],
                              plan.restrict
                            )
                          }" class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner" [ngStyle]="{
                              background: getColorForPlans(
                                plan.published.data[0],
                                plan.restrict
                              )
                            }"></span>
                        </div>
                      </div>
                      <div class="mt-2 mx-1" *ngIf="showPricing && plan.id == 5">
                        <label class="Corporation">{{lang.Pricing}} </label>
                        <select type="" class="form-control1 py-1 text-dark" id="pricingOptions" placeholder="Select"
                          (change)="(selectPricingOptions)" formControlName="pricingOptions">
                          <option selected value="">{{lang.Select}}</option>
                          <option *ngFor="let option of pricingOptions" [value]="option.key">
                            {{ option.display }}
                          </option>
                        </select>
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>

              <hr style="height: 2px; background-color: black" />
            </div>
          </div>
          <div *ngIf="plansError" class="text-danger text-end" style="font-size: 12px">
            {{lang.Please_select_atleast_one_plan}}
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="resetFormCreation()">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation?.invalid" (click)="addform()">
          {{lang.Save}}
        </button> -->
        <ng-container *ngIf="showaddplans">
          <button type="button" class="btn btn-primary" [disabled]="formCreation?.invalid" (click)="advisorAdd.addForm()">
            {{lang.Save}}
          </button>
        </ng-container>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" id="signupformedit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 85vw;margin-left: -23vw;top: -3vh;" *ngIf="showeditplans">
      <div class="modal-header">
        <h6 class="modal-title">
          <!-- {{lang.Edit_Signup_Form_Details}} -->
          Edit Enrollment Form Details
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closePlans()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="formCreation" (ngSubmit)="addform()" style="height: 75vh; overflow-y: auto; overflow-x: hidden;">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formName" placeholder={{lang.Title}}
                [(ngModel)]="editFormName" formControlName="formName" style="text-transform: capitalize" />
              <div *ngIf="form['formName'].touched && form['formName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    form['formName'].errors &&
                    form['formName'].errors['required']
                  ">
                  {{lang.Please_enter_form_title}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formDescription" placeholder={{lang.Description}}
                [(ngModel)]="editFormDescription" formControlName="formDescription"
                style="text-transform: capitalize" />
              <div *ngIf="
                  form['formDescription'].touched &&
                  form['formDescription'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['formDescription'].errors &&
                    form['formDescription'].errors['required']
                  ">
                  {{lang.Please_enter_form_description}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Logo}} </label>

              <div class="uploadCorporateLogo" *ngIf="editFormlogo && editFormlogo.length > 0; else showLogo">
                <label for="adminformlogo" class="adminformlogo">
                  <img [src]="editFormlogo" style="max-height: 50px; max-width: 100px" />
                </label>
                <input id="adminformlogo" class="form-control checking-field" style="display: none" type="file"
                  accept="image/*" formControlName="formlogo" (change)="uploadadminFormlogo($event)" />
              </div>
              <ng-template #showLogo>
                <input id="adminformlogo" class="form-control checking-field" type="file" accept="image/*"
                  formControlName="formlogo" (change)="uploadadminFormlogo($event)" />
              </ng-template>
              <div class="text-end" style="font-size: 10px">
                {{lang.Click_to_update_logo}}
              </div>
            </div>
            <div *ngIf="form['formlogo'].touched && form['formlogo'].invalid" class="help-block text-danger">
              <div *ngIf="
                  form['formlogo'].errors && form['formlogo'].errors['required']
                ">
                {{lang.Please_choose_form_logo}}
              </div>
            </div>
          </div>

          <!-- common-plans -->
          <app-common-plans
            #advisor
            [isAdvisor]="true"
            [viewPlan]="false"
            [advisorPackages]="productsArray"
            [allplansArray]="allplansArray"
            [selectedPlanLevels]="selectedPlanLevels"
            [editFormPricingOptions]="editFormPricingOptions"
            (submitTriggered)="editFormSubmit()"
          >
          </app-common-plans>

          <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar" style="
              font-size: 12px;
              width: 100%;
              max-height: 350px;
              overflow-y: scroll;
            " *ngIf="showPlans && false">
            <div *ngFor="let product of productsArray; let i = index" class="mt-2">
              <div class="display-center">
                <div class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                  style="width: 430px" [ngStyle]="{
                    'background-color': product.published
                      ? '#515151'
                      : '#dc3545'
                  }">
                  <span class="my-auto col-1">
                    <input type="checkbox" id="package{{ product.id }}" [disabled]="
                        allplansArray[product.name]?.disabled === true
                      " [checked]="
                        allplansArray[product.name]?.packageCheckbox === true
                      " (change)="
                        toggleAllPlans(product.name, product.id, $event)
                      " />
                  </span>
                  <div class="my-auto mb-1 col-10 text-center">
                    <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                        *ngIf="!product.published && role === 'ADMINISTRATOR'" class="bi bi-info-circle text-light"
                        title="Unpublished"></i></span>
                  </div>
                  <div *ngIf="role === 'ADMINISTRATOR'" title="{{
                      getTextForTooltip1(product.published, product.restrict)
                    }}" [ngStyle]="{
                      'border-color': getColorForPlans1(
                        product.published,
                        product.restrict
                      )
                    }" class="outer my-auto ms-3 col-2" data-bs-toggle="">
                    <span class="inner" [ngStyle]="{
                        background: getColorForPlans1(
                          product.published,
                          product.restrict
                        )
                      }"></span>
                  </div>
                </div>
              </div>

              <div class="display-center mt-3 mb-4 flex-wrap">
                <div *ngFor="
                    let plans of product.parents | keyvalue;
                    let k = index
                  ">
                  <div
                    class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                    *ngIf="isParentsGreaterThanOne(product.parents)" style="background-color: #515151; width: 210px">
                    <span class="my-auto col-1">
                      <input type="checkbox" [disabled]="
                      allplansArray[product.name] && allplansArray[product.name][plans.key]?.disabled ===
                          true
                        " [checked]="
                        allplansArray[product.name] && allplansArray[product.name][plans.key].checked ===
                          true
                        " (change)="
                          planKeyCheckbox(
                            product.name,
                            plans.key,
                            plans.value[0].parentId,
                            $event
                          )
                        " />
                    </span>
                    <span class="my-auto mb-1 col-9 text-center">{{
                      plans.key
                      }}</span>
                  </div>
                  <div [ngClass]="{
                      'display-center': !isParentsGreaterThanOne(
                        product.parents
                      ),
                      'flex-wrap': !isParentsGreaterThanOne(product.parents)
                    }">
                    <div *ngFor="let plan of plans.value">
                      <div [style.background-color]="
                          plan.backgroundColor
                            ? plan.backgroundColor
                            : '#5E152E'
                        "
                        class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex align-items-center gap-1 row py-1 rounded"
                        style="width: 210px">
                        <!-- *ngIf="plan.parentId != null" -->
                        <div class="my-auto col-1">
                          <input type="checkbox" id="planCheckbox{{ plans.id }}" [checked]="
                          allplansArray[product.name] && allplansArray[product.name][plan.name]
                                .planCheckbox === true
                            " [disabled]="
                            allplansArray[product.name] && allplansArray[product.name][plan.name]
                                ?.disabled === true
                            " (change)="
                              planCheckbox(
                                product.name,
                                plans.key,
                                plans.value[0].parentId,
                                plan.name,
                                plan.id,
                                $event
                              )
                            " />
                        </div>
                        <div class="my-auto col-9 mb-1" style="font-size: 12px">
                          <span>{{ plan.name }}</span>
                        </div>
                        <div *ngIf="role === 'ADMINISTRATOR'" title="{{
                            getTextForTooltip(
                              plan.published.data[0],
                              plan.restrict
                            )
                          }}" [ngStyle]="{
                            'border-color': getColorForPlans(
                              plan.published.data[0],
                              plan.restrict
                            )
                          }" class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner" [ngStyle]="{
                              background: getColorForPlans(
                                plan.published.data[0],
                                plan.restrict
                              )
                            }"></span>
                        </div>
                      </div>
                      <div class="mt-2 mx-1" *ngIf="showPricing && plan.id == 5">
                        <label class="Corporation">{{lang.Pricing }}</label>
                        <select class="form-control1 py-1 text-dark" id="pricingOptions" placeholder="Select"
                          [(ngModel)]="editFormPricingOptions" formControlName="pricingOptions">
                          <option value="">{{lang.Select}}</option>
                          <option *ngFor="let option of pricingOptions" [value]="option.key">
                            {{ option.display }}
                          </option>
                        </select>
                      </div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>

              <hr style="height: 2px; background-color: black" />
            </div>
          </div>
          <div *ngIf="plansError" class="text-danger text-end" style="font-size: 12px">
            {{lang.Please_select_atleast_one_plan}}
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetFormCreation()">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="editFormSubmit()">
          {{lang.Save}}
        </button> -->
        <button type="button" class="btn btn-primary" [disabled]="formCreation?.invalid" (click)="advisor.addForm()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit for Group contact_mail -->
<div class="modal fade" data-bs-backdrop="static" id="basicModaledit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="height: 40px">
        <div class="col-11 text-center">
          <h6 class="modal-title">{{lang.Edit_Group_Contact}}</h6>
        </div>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" (keypress)="alphabatesOnly($event)"/>

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" (keypress)="alphabatesOnly($event)" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_name_should_be_3_characters}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="phoneNum" placeholder={{lang.Phone_Number}}
                (change)="phoneFormatForGroupCont(adminform, 'phoneNum')" formControlName="phoneNum" />

              <div *ngIf="
                  grpcontact['phoneNum'].touched &&
                  grpcontact['phoneNum'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNum'].errors &&
                    grpcontact['phoneNum'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

              <select (change)="groupContactChange($event)" class="form-control" id="lengthofService"
                formControlName="role" name="adminrole">
                <option value="" disabled>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
              </select>
              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_Role}}
                </div>
              </div>
            </div>
            <div class="form-group col-6" *ngIf="ShowOthers">
              <!-- <div> -->
              <label for="Corporation" class="Corporation">{{lang.Others}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="roleName" placeholder={{lang.Others}}
                formControlName="roleName" />
              <div *ngIf="
                  grpcontact['roleName'].touched &&
                  grpcontact['roleName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['roleName'].errors &&
                    grpcontact['roleName'].errors['required']
                  ">
                  {{lang.please_enter_role}}
                </div>

                <!-- </div> -->
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editadminSubmit(adminform)">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- *******************************End Corp info -->
